var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoverWorker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 229,
    height: 218.859,
    viewBox: "0 0 229 218.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    cx: 80.667,
    cy: 80.667,
    r: 80.667,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22159",
    "data-name": "Trac\\xE9 22159",
    d: "M202.417,125.323q-1.515,3.2-3.053,6.351a47.242,47.242,0,0,0-5.078.648s-4.122.767-13.971,4.435c0,0-21.85,8.12-25.214,8.055s-15.543.772-20.17,3.29-37.207-2-37.207-2S63.2,157.987,58.935,162.5a56.4,56.4,0,0,0-4.951,6.58,80.666,80.666,0,0,0,57.585,37.136.223.223,0,0,1,.03.006c.076.008.154.019.233.03l.024,0q.353.048.71.089a.258.258,0,0,0,.044.006l.216.027c.019,0,.041,0,.059.006.23.027.457.054.689.078.013,0,.027,0,.044.006l.2.022.078.008.2.022c.021,0,.038,0,.057.006.145.013.294.03.441.043a.074.074,0,0,1,.023,0l.192.016c.032.005.068.008.1.011l.186.016.1.008.187.016c.038,0,.075.008.114.011l.291.025c.049,0,.1.008.146.011l.162.013.124.008c.054.006.114.009.166.014s.108.008.161.011.14.011.208.014.132.011.2.013l.127.008c.057.005.116.008.176.011l.127.008c.065.006.132.008.2.013.035,0,.07,0,.1.005l.278.016c.046,0,.092,0,.138.006l.162.008.138.009.175.008c.04,0,.087,0,.127.005.094.006.189.009.287.014a.666.666,0,0,1,.07,0l.227.008c.039,0,.079,0,.116.006.07,0,.133,0,.2.005.035,0,.073,0,.108,0l.24.008.062,0,.295.008c.035,0,.07,0,.105,0l.2,0c.037,0,.075,0,.113,0,.078,0,.154,0,.23.006h.068c.1,0,.2,0,.308.005h.07c.081,0,.159,0,.238,0h.1c.073,0,.146,0,.219,0h.937l.1,0h.159c.044,0,.081,0,.125,0h.146l.113,0c.051,0,.1,0,.154,0s.082,0,.122,0,.1,0,.143,0h.126l.141-.005c.043,0,.086,0,.13,0l.14,0,.118,0c.049,0,.1,0,.147-.006l.129,0,.133-.005c.046,0,.086,0,.132,0s.092-.005.136-.005.089,0,.132-.006l.144-.005c.038,0,.075,0,.116-.006s.1,0,.149-.005.08,0,.121-.006.1-.005.152-.005.07-.006.108-.006l.164-.008c.035,0,.07,0,.1-.006.068,0,.135-.008.2-.01.019,0,.039,0,.054,0,.087-.006.173-.008.259-.013h.008c.269-.016.54-.032.81-.051a.052.052,0,0,0,.022,0l.238-.016a.614.614,0,0,0,.076-.006c.065,0,.126-.008.192-.013a.57.57,0,0,0,.073-.006c.065,0,.13-.008.192-.013.022,0,.049,0,.07-.005l.206-.016.051-.005.211-.017c.021,0,.043,0,.065-.005l.2-.016.07-.008.189-.016.078-.005c.065-.008.13-.014.192-.019a.516.516,0,0,1,.07-.006c.065-.008.13-.013.195-.019l.068-.008c.067-.005.138-.013.208-.018a.3.3,0,0,1,.054-.006l.221-.024.038,0a80.115,80.115,0,0,0,24.538-6.592,98.768,98.768,0,0,0,.192-18.184c16.364-5.97,28.425-10.894,36.178-14.22q.822-1.374,1.585-2.783s0,0,0-.005c.034-.065.067-.127.1-.192.008-.016.018-.03.027-.046l.316-.591c.005-.014.013-.027.019-.04.032-.062.065-.122.1-.184.011-.019.019-.035.027-.051.1-.189.2-.381.294-.57.014-.025.028-.049.039-.073.03-.057.056-.108.083-.165.016-.032.032-.062.049-.094.049-.1.1-.194.148-.292.014-.027.028-.054.04-.082.025-.051.049-.1.074-.149.018-.035.037-.073.056-.11s.049-.1.07-.146.038-.078.056-.116c.039-.073.071-.144.106-.216.027-.049.051-.1.075-.152s.04-.086.063-.129.046-.092.068-.138.04-.087.059-.127l.076-.157c.025-.051.051-.106.073-.156s.06-.125.089-.189l.057-.116c.024-.051.049-.1.073-.156s.035-.076.051-.111l.1-.211c.016-.035.032-.07.046-.1.032-.071.065-.14.1-.208.014-.032.028-.062.04-.095.03-.062.057-.127.087-.189.011-.027.027-.062.04-.089.04-.089.078-.176.119-.264a.3.3,0,0,1,.019-.044c.032-.075.068-.154.1-.23a.75.75,0,0,0,.038-.086c.032-.068.062-.138.092-.209.011-.022.018-.043.029-.067.04-.092.078-.184.119-.276a.356.356,0,0,1,.016-.038c.035-.081.07-.161.1-.243.011-.022.022-.049.03-.07.035-.081.07-.162.106-.246.005-.011.008-.022.013-.032.04-.1.082-.192.122-.289a.124.124,0,0,1,.014-.032c.035-.084.067-.168.1-.254.008-.019.016-.037.024-.056.078-.192.157-.386.235-.578.006-.013.009-.024.014-.038.035-.083.07-.17.1-.257.006-.016.013-.032.019-.048.078-.195.154-.392.23-.586a.225.225,0,0,1,.014-.032c.035-.089.067-.178.1-.268,0-.011.011-.027.013-.038.076-.2.149-.394.225-.591.005-.016.011-.03.016-.046.032-.089.068-.183.1-.275a.142.142,0,0,0,.008-.016c.073-.2.145-.4.219-.608a.151.151,0,0,1,.013-.032c.033-.094.067-.189.1-.283a.07.07,0,0,1,.006-.016c.073-.2.143-.411.213-.614,0-.011.008-.021.011-.03.106-.3.208-.613.308-.918a.27.27,0,0,0,.011-.032c.1-.311.2-.621.3-.935a.022.022,0,0,0,0-.014c.1-.316.2-.632.294-.951l0-.008c.065-.211.127-.424.188-.635a.134.134,0,0,0,.006-.014c.03-.1.059-.207.089-.313l0,0c.059-.211.119-.424.178-.635,0-.008.005-.018.008-.027.089-.316.176-.637.259-.956a.01.01,0,0,0,0-.008c.086-.324.17-.646.251-.97,0,0,0-.008,0-.011.084-.327.163-.651.241-.978v-.006c.078-.326.156-.653.229-.983v-.006c.051-.218.1-.437.146-.657a.109.109,0,0,0,0-.013c.025-.106.046-.211.068-.319l0-.006c.046-.221.092-.44.138-.662v-.006c.068-.327.132-.657.195-.983a.1.1,0,0,1,.006-.03q.06-.329.121-.654v0c.019-.108.038-.216.057-.321,0-.008,0-.016.005-.025.039-.219.076-.44.113-.662v0c.02-.108.035-.211.054-.319a.1.1,0,0,1,.006-.03c.035-.216.07-.435.1-.652,0-.011,0-.018.006-.029.016-.1.03-.2.046-.306a.077.077,0,0,0,0-.025c.033-.216.065-.435.1-.65,0-.016,0-.03.005-.046.014-.095.028-.189.041-.283,0-.014,0-.03.005-.046.03-.214.057-.426.087-.64,0-.019,0-.035.005-.054.014-.1.025-.195.039-.292,0-.011,0-.019,0-.03.013-.108.027-.218.04-.33l0-.013c.011-.1.024-.2.035-.3l.008-.056c.011-.1.022-.2.032-.295,0-.008,0-.018,0-.027.013-.108.024-.219.035-.33,0-.011,0-.016.005-.027.008-.1.018-.192.029-.29,0-.018,0-.043.006-.065.011-.1.022-.208.033-.313s.021-.216.032-.328c0-.019,0-.037.005-.059.009-.087.016-.173.025-.26a.6.6,0,0,1,.006-.075c.008-.094.016-.187.024-.278,0-.013,0-.03.006-.043.008-.1.016-.206.024-.308,0-.027.006-.057.008-.081.005-.082.011-.159.019-.241,0-.029,0-.059.005-.089.008-.1.016-.2.022-.294a.225.225,0,0,0,0-.041c.008-.094.014-.186.022-.281,0-.035.005-.07.005-.105.006-.076.011-.149.016-.225,0-.03,0-.059.005-.089.008-.1.014-.206.02-.308,0-.02,0-.041,0-.06.006-.083.011-.17.016-.257,0-.032,0-.064.005-.1.006-.078.009-.159.014-.24,0-.024,0-.051,0-.076.006-.1.011-.211.016-.316a.316.316,0,0,1,0-.049c0-.089.008-.176.011-.264,0-.035,0-.065.006-.1,0-.083.005-.164.011-.248v-.062c.005-.1.008-.209.013-.311a.806.806,0,0,1,0-.087l.008-.24a.948.948,0,0,1,0-.095c0-.089,0-.176.005-.264a.318.318,0,0,0,0-.049c0-.108.006-.213.008-.319v-.075c0-.082,0-.163.006-.244,0-.032,0-.07,0-.1,0-.092,0-.186,0-.28v-.03c0-.1,0-.209.006-.314v-.33c0-.03,0-.062,0-.094V126c0-.04,0-.082,0-.122v-.251c0-.056,0-.113,0-.167v-.082c0-.064,0-.132,0-.2v-.046c0-.076,0-.154,0-.232a.051.051,0,0,0,0-.019q0-.4-.016-.8l-.583,1.24",
    transform: "translate(-53.984 -124.083)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22220",
    "data-name": "Trac\\xE9 22220",
    d: "M127.323,27.567c-7.85,3.817-14.714,15.464-12.207,28.844-1.091,1.04-3.633,4.292-1.429,3.973,6.226-1.023,18.185-4.686,23.528-2.258s7.685,4.9,21.445,1.92c7.906-1.894,20.087-1.38,22.45-1.75s-.967-4.3-5.385-7.188c-2.321-12.2-5.389-24.517-16.429-27.677-2.61-2.106-7.647-3.471-13.137-3.471-6.861,0-14.422,2.132-18.835,7.607",
    transform: "translate(-112.815 -19.96)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22245",
    "data-name": "Trac\\xE9 22245",
    d: "M173.384,49.026c-7.112.657-5.011,4.854-3.869,10.632s6.024,6.475,10.557,6.308,10.281-.894,11.866-6.53c.548-1.745-.13-4.946-3.633-7.725-.419-2.66-2.9-3.374-6.275-3.374-2.545,0-5.592.405-8.647.689",
    transform: "translate(-168.317 -48.337)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22248",
    "data-name": "Trac\\xE9 22248",
    d: "M113.689,61.725c-1.213.639-2.21,7.666-.152,7.055s15.227-2.558,33.642-3.822c0,0,3.471-7.2.507-7.847a4.573,4.573,0,0,0-.9-.062c-5.8,0-31.969,4.076-33.1,4.676",
    transform: "translate(-112.35 -57.049)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22252",
    "data-name": "Trac\\xE9 22252",
    d: "M200.913,61.9c-.44.075-.8.14-1.018.178q-7.476,19.45-16.931,39.584-1.515,3.2-3.053,6.351a47.246,47.246,0,0,0-5.078.648s-4.122.767-13.971,4.435c0,0-21.85,8.12-25.214,8.055s-15.543.772-20.17,3.29-37.207-2-37.207-2-34.524,11.889-38.79,16.4S25.562,159.092,3.917,195.553c-.648,2.517-2.831,8.981-2.874,14.83v.345c.022,3.048.653,5.9,2.415,7.907h8.26c19.124-3.1,23.582-8.663,23.582-8.663s-5.545.618,2.855-11.149S49.924,183.7,49.924,183.7l2.942,33.193,52.879,1.745H129.37l.4-11.832s8.4-26.053,6.3-48.744c31.091-11.343,46.64-18.906,46.64-18.906s13.309-2.944,19.046-10.087c15.17-53.633,16.264-68.195,13.309-69.335a.922.922,0,0,0-.3-.035c-1.242,0-5.735.786-13.855,2.2",
    transform: "translate(-1.043 -59.697)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22260",
    "data-name": "Trac\\xE9 22260",
    d: "M199.525,60.276c-6.3,16.809-17.788,46.98-19.614,46.183s-19.046,5.084-19.046,5.084-21.853,8.12-25.216,8.055-15.543.772-20.17,3.29-37.207-2-37.207-2-34.524,11.889-38.79,16.4S25.562,157.537,3.917,194c-.648,2.517-2.831,8.981-2.874,14.83v.345c.022,3.048.653,5.9,2.415,7.907h8.26c19.124-3.1,23.582-8.663,23.582-8.663s-5.545.618,2.855-11.149,11.769-15.127,11.769-15.127l2.942,33.193,52.879,1.745H129.37l.4-11.832s8.4-26.053,6.3-48.744c31.091-11.343,46.64-18.906,46.64-18.906s13.309-2.944,19.046-10.087c4.487-13.028,17.934-62.2,13.309-69.335a5.594,5.594,0,0,0-4.959-2.712c-4.9,0-10.586,4.811-10.586,4.811",
    transform: "translate(-1.043 -55.465)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 229,
    height: 197.664,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22285",
    "data-name": "Trac\\xE9 22285",
    d: "M134.238,100.851l-2.939,1.469a29.6,29.6,0,0,1,1.145,3.722c.214,1.257.4,25.827-9.116,31.175.948,10.073,22.177,20.135,35.037,9.992-1.985-3.031-3.46-5.97-3.03-7.139s2.231-8.015,3.476-10.13-21.064-35.162-21.064-35.162Z",
    transform: "translate(-123.328 -94.779)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22300",
    "data-name": "Trac\\xE9 22300",
    d: "M125.256,75.615l.287,10.524s.762,10.935-1.648,11.1-.8,1.153-2.876,2.841,1.853,8.142,2.647,10.065,5.275,2.785,6,.538c7.121,17.083,21.559,19.376,31.078,17.18s12.569-15.154,13.436-18.511,2.169-28.936,2.169-28.936l-.535-7.652Z",
    transform: "translate(-120.418 -72.765)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22351",
    "data-name": "Trac\\xE9 22351",
    d: "M127.323,27.567c-7.85,3.817-14.714,15.464-12.207,28.844-1.091,1.04-3.633,4.292-1.429,3.973,6.226-1.023,18.185-4.686,23.528-2.258s7.685,4.9,21.445,1.92c7.906-1.894,20.087-1.38,22.45-1.75s-.967-4.3-5.385-7.188c-2.321-12.2-5.389-24.517-16.429-27.677-2.61-2.106-7.647-3.468-13.137-3.471-6.858,0-14.424,2.132-18.835,7.607",
    transform: "translate(-112.815 -19.96)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22398",
    "data-name": "Trac\\xE9 22398",
    d: "M173.384,49.026c-7.112.657-5.011,4.854-3.869,10.632s6.024,6.475,10.557,6.308,10.281-.894,11.866-6.53c.548-1.745-.13-4.946-3.633-7.725-.419-2.66-2.9-3.374-6.277-3.374-2.542,0-5.592.405-8.644.689",
    transform: "translate(-168.317 -48.337)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22401",
    "data-name": "Trac\\xE9 22401",
    d: "M113.689,61.725c-1.213.639-2.21,7.666-.152,7.055s15.227-2.558,33.642-3.822c0,0,3.471-7.2.507-7.847a4.572,4.572,0,0,0-.9-.062c-5.8,0-31.969,4.076-33.1,4.676",
    transform: "translate(-112.35 -57.049)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3762",
    "data-name": "Groupe 3762",
    transform: "translate(-1.043 21.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3711",
    "data-name": "Groupe 3711",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3763",
    "data-name": "Groupe 3763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22154",
    "data-name": "Trac\\xE9 22154",
    d: "M195.891,80.669A80.669,80.669,0,1,1,115.224,0a80.667,80.667,0,0,1,80.667,80.667",
    transform: "translate(-13.357 -0.001)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22402",
    "data-name": "Trac\\xE9 22402",
    d: "M238.285,101.866A101.866,101.866,0,1,1,136.421,0,101.863,101.863,0,0,1,238.285,101.866",
    transform: "translate(-34.554 -21.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22403",
    "data-name": "Trac\\xE9 22403",
    d: "M195.891,80.669A80.669,80.669,0,1,1,115.224,0a80.667,80.667,0,0,1,80.667,80.667",
    transform: "translate(-13.357 -0.001)",
    fill: "#299bd4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3713",
    "data-name": "Groupe 3713",
    transform: "translate(22.242 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3712",
    "data-name": "Groupe 3712",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22155",
    "data-name": "Trac\\xE9 22155",
    d: "M199.894,62.066c-.691,2.067-1.421,4.146-2.171,6.237a291.8,291.8,0,0,1-17.81,39.7c-.732.078-2.072.24-3.73.533,0,0-4.79.851-15.321,4.551,0,0-21.85,8.12-25.211,8.053s-15.548.772-20.172,3.292-37.2-2-37.2-2-34.525,11.885-38.793,16.4S25.558,159.075,3.916,195.539c-1.056,4.112-6.218,18.768.567,24.047,25.27-2.709,30.816-9.627,30.816-9.627s-5.546.619,2.858-11.145,11.767-15.132,11.767-15.132l2.942,33.2,76.48,2.523.424-12.609s8.4-26.054,6.3-48.744c31.091-11.345,46.64-18.906,46.64-18.906s13.309-2.944,19.046-10.087c15.122-55.5,15.8-68.433,13.312-69.335-.8-.289-2.3.524-4.473,1.337a18.783,18.783,0,0,1-9.587,1.208c-.513-.073-.921-.154-1.118-.2",
    transform: "translate(-22.242 -21.922)",
    fill: "#fbde00"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3715",
    "data-name": "Groupe 3715",
    transform: "translate(34.53 78.488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3714",
    "data-name": "Groupe 3714",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22156",
    "data-name": "Trac\\xE9 22156",
    d: "M270.318,128.082c.84,9.662,4.619,30.675,14.287,36.561s18.909-8.406,18.909-8.406L276.62,122.2Z",
    transform: "translate(-133.478 -123.391)",
    fill: "#536551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22157",
    "data-name": "Trac\\xE9 22157",
    d: "M243.812,138.043c1.261,8.828,2.939,29.838,10.087,37.4s-15.13,8.406-15.13,8.406-12.185-25.634-9.246-39.922,14.29-5.883,14.29-5.883",
    transform: "translate(-118.319 -128.31)",
    fill: "#536551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22158",
    "data-name": "Trac\\xE9 22158",
    d: "M279.613,88.269c1.264,15.546,12.747,43.279,21.853,42.442s26.478-75.64,26.478-75.64l-43.285-4.622Z",
    transform: "translate(-136.893 -97.026)",
    fill: "#1b2264"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3717",
    "data-name": "Groupe 3717",
    transform: "translate(22.242 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3716",
    "data-name": "Groupe 3716",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22160",
    "data-name": "Trac\\xE9 22160",
    d: "M163.119,227.826c-12.193,6.408-41.216,13.047-77.615,9.111-6.335,7.086-9.711,10.165-9.711,10.165l2.194,4.114s62.563,8.288,85.578-11.453c.983-9.1-.446-11.937-.446-11.937",
    transform: "translate(-49.71 -83.717)",
    fill: "#536551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22161",
    "data-name": "Trac\\xE9 22161",
    d: "M48.848,256.184C37.873,246.4,23.54,241.46,21.282,241.373l7.55-13.96S53.6,233.84,55.763,246.952c-4.921,6.774-6.915,9.233-6.915,9.233",
    transform: "translate(-29.679 -83.565)",
    fill: "#536551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22162",
    "data-name": "Trac\\xE9 22162",
    d: "M190.24,224.594l2.215-.319-.144-1.021-1.215.175-.516-3.59-1,.149Z",
    transform: "translate(-91.521 -80.782)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22163",
    "data-name": "Trac\\xE9 22163",
    d: "M194.156,224.045l.883-.124-.273-1.9c-.022-.165-.1-.673.4-.743.47-.07.548.476.572.64l.268,1.858.88-.127-.275-1.9a1.865,1.865,0,0,0-.454-1.21,1.014,1.014,0,0,0-.859-.257.8.8,0,0,0-.694.54l-.03.051-.221-1.559-.859.122Z",
    transform: "translate(-92.96 -80.589)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22164",
    "data-name": "Trac\\xE9 22164",
    d: "M199.575,222.05a.739.739,0,1,1,1.434-.208.74.74,0,1,1-1.434.208m-.9.13a1.643,1.643,0,1,0,1.348-2.075,1.72,1.72,0,0,0-1.348,2.075",
    transform: "translate(-94.857 -80.873)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22165",
    "data-name": "Trac\\xE9 22165",
    d: "M204.265,217.891l-.88.125.111.777.881-.127Zm.162,1.137-.878.127.5,3.468.88-.124Z",
    transform: "translate(-96.594 -80.066)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22166",
    "data-name": "Trac\\xE9 22166",
    d: "M207.787,220.14a1.042,1.042,0,0,0-1.226-.921,1.137,1.137,0,0,0-.942,1.326.986.986,0,0,0,.772.877c.378.1.762.03.808.376.032.221-.13.308-.278.33a.325.325,0,0,1-.351-.319l-.81.116a1.092,1.092,0,0,0,1.264.98,1.181,1.181,0,0,0,1.046-1.359c-.1-.7-.591-.867-1.116-.956-.243-.046-.464-.019-.5-.3a.277.277,0,0,1,.211-.322c.259-.037.306.222.321.295Z",
    transform: "translate(-97.41 -80.549)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22167",
    "data-name": "Trac\\xE9 22167",
    d: "M210.236,217.01l-.883.132.164,1.135-.389.059.113.772.384-.054.389,2.693.883-.121-.389-2.7.384-.054-.114-.778-.381.059Z",
    transform: "translate(-98.705 -79.742)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22168",
    "data-name": "Trac\\xE9 22168",
    d: "M180.156,230.552l2.35-.34.557-1.148.259,1.8,0,0-.411.816-2.545.368Z",
    transform: "translate(-88.059 -84.172)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22169",
    "data-name": "Trac\\xE9 22169",
    d: "M182.193,227.99l1.286-2.577.259,1.8h0l-.292.6Z",
    transform: "translate(-88.807 -82.83)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22170",
    "data-name": "Trac\\xE9 22170",
    d: "M184.482,220.094l-1.35,2.815.005.005a5.534,5.534,0,0,1,1.286,2.766c.367,2.566-1.129,4.895-3.342,5.217s-4.306-1.5-4.673-4.065,1.07-4.906,3.279-5.227l.473-.891,1.586-.23-1.286,2.583h-.013a2.328,2.328,0,0,0-.513.013,3.26,3.26,0,1,0,3.209,2.8,3.357,3.357,0,0,0-1.745-2.553l.011,0,1.5-3.009Z",
    transform: "translate(-86.661 -80.876)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22171",
    "data-name": "Trac\\xE9 22171",
    d: "M165.66,194.106c5.2,12.958,3.109,53.185,1.8,59.106s-.465,49.852,1.791,52.99.84-1.683.84-1.683-1.223-19.16,0-49.173c.962-23.239,3.387-50.964-4.427-61.24",
    transform: "translate(-82.732 -71.326)",
    fill: "#c5d0c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22172",
    "data-name": "Trac\\xE9 22172",
    d: "M94.124,162.408c-6.262,2.277-18.06,6.58-20.529,7.539-3.4,1.316-11.273,5.989-11.273,5.989S59.6,177.5,59.408,178.81a23.173,23.173,0,0,0-4.77,5c.7,1.089,1.421,2.164,2.169,3.215,3.079-4.157,5.5-6.993,6.259-6.991h.005c2.328.049,7.345,5.843,8.3,6.969-.8-.986-4.271-5.675-1.883-10.208,2.053-3.906,13.974-7.329,20.011-7.329,1.843,0,3.136.319,3.436,1.04,1.116,2.677,2.547,6.053,5.808,6.378a44.949,44.949,0,0,1-4.617-14.479m-22.755,24.6c.1.124.157.189.157.189s-.054-.068-.157-.189",
    transform: "translate(-41.936 -59.678)",
    fill: "#8f7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22173",
    "data-name": "Trac\\xE9 22173",
    d: "M77.171,157.742c-7.083,2.985-19.184,7.131-24.455,8.966S41.7,172.029,39.1,174.865c-5.487,2.823-12.564,15.127-16.072,21.594S9.067,222.977,3.533,231.58c-1.677,2.426-5.349,16.624-2.458,22.753S21.493,271.5,34.6,280.1c8.19,4.614,11.548,9.081,15.33,8.374,3.466-.683,1.391-2.074,1.391-2.074s-.567.7-7.039-2.807A273.539,273.539,0,0,1,20.91,268.984c-7.62-5.316-14.355-11.364-16.44-15.97s-.37,2.612-.37,2.612S.845,252.11,1.671,244.633s3.3-11.591,6.016-16.375,14.276-26.545,14.276-26.545S33.905,180.549,39.332,177.1c.187-1.31,2.915-2.877,2.915-2.877s7.869-4.671,11.273-5.989,24.451-8.965,24.451-8.965Z",
    transform: "translate(-21.859 -57.964)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22174",
    "data-name": "Trac\\xE9 22174",
    d: "M69.448,239.737c-.405,2.294-3.857,6.186-5.632,7.655s-9.373,11.9-11.9,15.376-4.81,6.286-5.786,9.276-.14,4.835-3.015,1.92-6.118-3.22-8.6-2.32-.94,3.309-.94,3.309-2.62-3.582.173-4.516,10.408,1.17,10.408,1.17,4.927-8.226,7.812-11.415S64.44,244.113,64.44,244.113s5.95-7.688,5.008-4.376",
    transform: "translate(-33.787 -87.789)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22175",
    "data-name": "Trac\\xE9 22175",
    d: "M80.784,294.458a67.16,67.16,0,0,1-1.4-16.564s-3.39-14.109-2.847-21.238l2.247-3.128s1.037,22.391,3.241,25.057c1.57,2.728-.054,2.571-.054,2.571s-1.08,8.147.432,13.455c-.283.352-1.621-.154-1.621-.154",
    transform: "translate(-49.962 -93.162)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22176",
    "data-name": "Trac\\xE9 22176",
    d: "M64.852,189.447c6.27,1.6,12.963,13.439,14.511,19.06.932,2.793,1.053.854,1.105-1.721s-10.727-19.776-15.616-17.339",
    transform: "translate(-45.689 -69.527)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22177",
    "data-name": "Trac\\xE9 22177",
    d: "M185.919,158.047c8.528-4.49,23.233.135,23.233.135s-19.749-2.1-23.114,1.68c1.261,0-.978-1.967-.978-1.967Z",
    transform: "translate(-89.861 -57.355)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22178",
    "data-name": "Trac\\xE9 22178",
    d: "M213.846,148.94c10.214-3.479,23.836-7.726,29.886-10.432s9.085-3.476,11.729-3.092l2.647.389a45.793,45.793,0,0,0-9.46,2.7c-4.538,1.932-32.909,11.2-32.909,11.2Z",
    transform: "translate(-100.438 -49.726)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22179",
    "data-name": "Trac\\xE9 22179",
    d: "M213.809,161.99c7.139-1.259,41.6-12.747,50.006-19.468C271.8,140,275.719,138.878,279.5,133s9.527-28.015,15.13-62.472c-.838-.424-1.118.276-1.118.276s-9.387,54.627-15.689,61.35c-2.1,4.628-15.127,8.687-15.127,8.687s-33.763,17.788-49.727,18.633c0,2.518-1.262,2.936.843,2.518",
    transform: "translate(-99.977 -25.865)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22180",
    "data-name": "Trac\\xE9 22180",
    d: "M283.6,110.949c.84-2.8,7.282-14.009,9.244-19.049s10.645-24.093,10.364-26.615c-.84.281-10.083,22.412-10.083,22.412s-14.849,26.335-9.525,23.252",
    transform: "translate(-125.646 -23.99)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22181",
    "data-name": "Trac\\xE9 22181",
    d: "M206.98,190.626c3.363,19.746-1.061,55.486-3.139,60.205s-1.788,23-1.813,25.892,3.12,17.674,5.632,17.093-3.784-8.609-4.127-15,.583-22.229.583-22.229,3.255-15.116,5.068-22.38,1.01-43.6-2.2-43.579",
    transform: "translate(-96.095 -70.047)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22182",
    "data-name": "Trac\\xE9 22182",
    d: "M160.713,159.089c-2.361-3.827-4.8-6.132-7.828-5.924-1.283.089-5.564-1.791-10.5-3.676-6.724-2.564-14.657-5.13-17.885-2.715-5.6,4.187-2.409,9.1-2.409,9.1l8.439-4.387,20.945,5.962,4.387,2.925Z",
    transform: "translate(-66.388 -53.578)",
    fill: "#1b2264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22183",
    "data-name": "Trac\\xE9 22183",
    d: "M135.527,176.005s11.764,6.048,18.271,4.711,11.3-6.537,11.3-6.537l-.489-5.129L134.2,171.673Z",
    transform: "translate(-71.171 -62.119)",
    fill: "#fce0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22184",
    "data-name": "Trac\\xE9 22184",
    d: "M158.366,147.208c-1.986-3.03-3.46-5.97-3.034-7.139s2.234-8.014,3.48-10.13S137.75,94.774,137.75,94.774l-3.512,6.075-2.939,1.469a29.9,29.9,0,0,1,1.148,3.723c.208,1.256.4,25.827-9.119,31.175.948,10.073,22.177,20.135,35.038,9.992",
    transform: "translate(-67.177 -34.826)",
    fill: "#fce0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22185",
    "data-name": "Trac\\xE9 22185",
    d: "M175.952,151.746c-4.354,10.314-4.471,14.125-3.449,17.855a30.733,30.733,0,0,1,.643-7.139s1.205,4.606,2.979,6.38l.913-1.456s-3.3-3.7-3.228-6.367,2.9-9.325,2.9-9.325Z",
    transform: "translate(-85.052 -55.742)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22186",
    "data-name": "Trac\\xE9 22186",
    d: "M131.1,106.99c2.717,6.278-.151,25.232-4.83,30.878l-3.2,3.266.719,1.215s4.611-4.754,6.262-10.189,3.941-18.147,2.18-25.248a1.108,1.108,0,0,0-1.135.078",
    transform: "translate(-67.082 -39.237)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22187",
    "data-name": "Trac\\xE9 22187",
    d: "M152.132,170.89c-6.426,3.3-11.515,1.178-16.507-2.277s-14.473-12.239-14.59-14.832.765-3.6.765-3.6l3.566-3.417a9.127,9.127,0,0,0-7.837,4.854c-2.512,4.927,3.155,20.883,8.874,26.57,2.134-4.9,7.78-5.673,12-5.206s6.74,1.243,9.914.454l3.182-.791s4.368-2.774,6.694,3.339c4.795-4.9,3.39-14.111.076-18.066l-4.082,1.424s2.774,4.368.738,7.931Z",
    transform: "translate(-64.821 -53.929)",
    fill: "#1b2264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22188",
    "data-name": "Trac\\xE9 22188",
    d: "M177.381,171.105l-2.634-7.369,3.474-1.569Z",
    transform: "translate(-86.071 -59.59)",
    fill: "#1b2264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22189",
    "data-name": "Trac\\xE9 22189",
    d: "M208.959,77.879c.24,3.5-.395,12.38-.395,12.38s.96,2.085,2.645,1.085a5.536,5.536,0,0,0,2.256-2.35s-2.126,1.027-2.485-.929.7-2.683,1.4-2.075l.7.614s.259-2.655-1.337-3.423.394-.689.383-3.984a7.212,7.212,0,0,0-1.661-4.935l-1.078.294Z",
    transform: "translate(-98.497 -27.288)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22190",
    "data-name": "Trac\\xE9 22190",
    d: "M128.978,120.423l1,1.691-1.829-.972s-5.63,2.941-6.861-5.324c-2.884-5.972-2.242-8.768,2.228-10.835-.357-1.95,2.9-8.768,2.9-8.768l7.369,17.5Z",
    transform: "translate(-65.784 -35.355)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22191",
    "data-name": "Trac\\xE9 22191",
    d: "M175.812,72.767l.532,7.652s-1.3,25.581-2.169,28.936-3.922,16.311-13.436,18.512-23.955-.1-31.075-17.182c-.724,2.25-5.205,1.385-6-.538s-4.73-8.387-2.647-10.065.47-2.674,2.874-2.842,1.65-11.1,1.65-11.1l-.289-10.524Z",
    transform: "translate(-66.108 -26.739)",
    fill: "#fce0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22192",
    "data-name": "Trac\\xE9 22192",
    d: "M179.217,80.527c-.691,9.055-2.01,12.223-1.78,15.5s.035,13.185-1.956,16.175c-.5,5.532-4.625,15.7-8.66,17.739s-10.67,4.482-17.428,2.088-17.234-10.886-18.723-16.493c-2.123-8.423-1.575-10-3.644-11.4s-2.52,1.713-1.991,3l.524,1.281s-4.362-5.851,1.386-5.368c2.936,1.116,3.031,2.428,4.943,11.081s12.607,13.846,17.847,16.559,15.948-1.324,18.436-3.474,6.189-15.37,6.189-15.37a29.912,29.912,0,0,0,1.882-13.973l.216-6.386s.457-9.26-.476-10.073,3.234-.886,3.234-.886",
    transform: "translate(-67.414 -29.59)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22193",
    "data-name": "Trac\\xE9 22193",
    d: "M165.179,134.893a2.213,2.213,0,0,0-.753,1.807s-2-1.948.753-1.807",
    transform: "translate(-82.02 -49.565)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22194",
    "data-name": "Trac\\xE9 22194",
    d: "M185.6,144.522a12.878,12.878,0,0,1-3.46.789s1.991,3.378,3.46-.789",
    transform: "translate(-88.788 -53.106)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22195",
    "data-name": "Trac\\xE9 22195",
    d: "M128.05,117.454c-.953,2.153,1.764,6.472,3.187,6.375l.621,1.051s-6.429-2.41-4.846-8.123c1.448.34,1.037.7,1.037.7",
    transform: "translate(-68.438 -42.903)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22196",
    "data-name": "Trac\\xE9 22196",
    d: "M131.885,130.945c-2.788,1.07-4.573.646-4.733-.113.775.167,4.9-.559,4.849-1.324s-.116,1.437-.116,1.437",
    transform: "translate(-68.582 -47.529)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22197",
    "data-name": "Trac\\xE9 22197",
    d: "M179.376,156.358c1.372-.867,2.736-4.916,2.361-7.193.824-.832,1.791-1.116,2.142-.813s.653,6.327,1.975,6.348-3.6,5.084-6.478,1.659",
    transform: "translate(-87.772 -54.47)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22198",
    "data-name": "Trac\\xE9 22198",
    d: "M120.48,99.062c2.814-.629,2.306,1.6,3.725,3.039a10.051,10.051,0,0,1,2.3,4.676l.048.657,1.713-.559s-2.523-7.955-1.17-13.757a39.854,39.854,0,0,0,1.018-10.624l-.381-2.388-13.078,1.564s.051,7.031-1.64,8.028l-1.686.994s4.211.586,4.778-.77c-2.349,4.119-4.829,3.19-4.829,3.19s2.385,2.693,4.668.778c.161,2.4-1.524,3.4-2.635,3.258l-1.1-.145a3.077,3.077,0,0,0,3.617,1.51c-.565,1.356-1.569,2.741-1.024,4.244.738-2.029,2.3-1.694,2.3-1.694s1.267-.757,3.377-2",
    transform: "translate(-62.749 -29.435)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22199",
    "data-name": "Trac\\xE9 22199",
    d: "M128.946,109.293c-1.734.34-4.206,2.709-4.206,2.709l-.378.905s-1.1-3.22,1.416-4.933,3.168,1.318,3.168,1.318",
    transform: "translate(-67.468 -39.484)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22200",
    "data-name": "Trac\\xE9 22200",
    d: "M128.569,93.482c-1.116,1.818-.513,2.747-.513,2.747s-11.67-2.1-12.885-4.338l.054-1.748s9.152,4.208,13.344,3.339",
    transform: "translate(-64.179 -33.124)",
    fill: "#003844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22201",
    "data-name": "Trac\\xE9 22201",
    d: "M164.363,103.672c-2.636-3.112-10.24-1.924-10.451,1.383s7.909,3.188,9.959,1.07.491-2.453.491-2.453",
    transform: "translate(-78.414 -37.43)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22202",
    "data-name": "Trac\\xE9 22202",
    d: "M164.109,104.351c-2.218-2.515-8.668-1.535-8.857,1.146s6.691,2.563,8.436.84.421-1.986.421-1.986",
    transform: "translate(-78.906 -37.81)",
    fill: "#ecf8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22203",
    "data-name": "Trac\\xE9 22203",
    d: "M193.334,102.193c1.912-3.173,8.7-3.038,9.3-.035s-6.51,3.9-8.56,2.221-.735-2.186-.735-2.186",
    transform: "translate(-92.748 -36.694)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22204",
    "data-name": "Trac\\xE9 22204",
    d: "M194.456,102.732c1.626-2.577,7.38-2.483,7.88-.051s-5.527,3.177-7.263,1.815-.616-1.764-.616-1.764",
    transform: "translate(-93.182 -37.05)",
    fill: "#ecf8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22205",
    "data-name": "Trac\\xE9 22205",
    d: "M165.868,105.71a1.66,1.66,0,1,1-1.737-1.31,1.542,1.542,0,0,1,1.737,1.31",
    transform: "translate(-81.602 -38.361)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22206",
    "data-name": "Trac\\xE9 22206",
    d: "M204.017,103.694a1.453,1.453,0,1,1-1.518-1.142,1.351,1.351,0,0,1,1.518,1.142",
    transform: "translate(-95.772 -37.682)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22207",
    "data-name": "Trac\\xE9 22207",
    d: "M165.461,92.747c-.57-1.937-14.454-2.509-15.554.64s14.789.954,14.789.954Z",
    transform: "translate(-76.923 -33.497)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22208",
    "data-name": "Trac\\xE9 22208",
    d: "M202.53,91.669c-.667-1.887-11.5-1.612-12,1.586s11.582.038,11.582.038Z",
    transform: "translate(-91.866 -33.252)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22209",
    "data-name": "Trac\\xE9 22209",
    d: "M205.648,105.314c2.634-2.358,2.2-5.384,1.067-9.028s2.463,0,2.463,0l.754,7.713Z",
    transform: "translate(-97.426 -34.786)",
    fill: "#132741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22210",
    "data-name": "Trac\\xE9 22210",
    d: "M159.634,105.08c-2.969.759-10.579,2.045-12.769.089s-1.421-6.107-.076-6.953,4.906-.61,15.168-.816c1.753.491.654,6.931-2.323,7.68m5.467-9.789c-1.232-1.664-12.766-1.8-18.071-1.07s-5.4.91-7.013,5.178,1.867,9.025,5.162,9.336,14.987-.47,16.888-2.356,3.253-6.067,3.512-7.6.257-2.982-.478-3.487",
    transform: "translate(-73.159 -34.467)",
    fill: "#1c3a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22211",
    "data-name": "Trac\\xE9 22211",
    d: "M201.253,103.552c-1.769.67-6.472,1.777-8.384-.1s-2.407-5.781-1.724-6.556c.521-.6,2.069-.578,5.816-.559,1.118.008,2.437.011,3.979,0,1.267.486,2.091,6.54.313,7.213m3.433-5.848c-.194-1.442-.548-2.815-1.154-3.3-1.21-1.58-8.835-1.874-12.158-1.259s-3.339.784-3.374,4.784,3.406,8.544,5.649,8.882,9.754-.232,10.554-1.983.683-5.678.483-7.123",
    transform: "translate(-90.941 -34.116)",
    fill: "#1c3a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22212",
    "data-name": "Trac\\xE9 22212",
    d: "M138.089,97.826l-.249-2.385-1.1-.221-.319.535.665.467.316,1.418Z",
    transform: "translate(-71.988 -34.989)",
    fill: "#234b7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22213",
    "data-name": "Trac\\xE9 22213",
    d: "M137.919,98.25,137,100.47l-1.118-.1-.149-.608.767-.257.71-1.267Z",
    transform: "translate(-71.735 -36.097)",
    fill: "#234b7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22214",
    "data-name": "Trac\\xE9 22214",
    d: "M141.065,97.989c-4.492-1.867-4.976-.627-4.189.653a3.364,3.364,0,0,0,2.158,1.492Z",
    transform: "translate(-72.041 -35.657)",
    fill: "#1c3a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22215",
    "data-name": "Trac\\xE9 22215",
    d: "M175.529,106.021c5.737-3.106,8.611-3.028,10.443-1.456s-1.194-7.031-1.194-7.031l-8.717-.151Z",
    transform: "translate(-86.358 -35.784)",
    fill: "#1c3a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22216",
    "data-name": "Trac\\xE9 22216",
    d: "M184.483,119.377a3.766,3.766,0,0,0,2.072,2.934c1.132.467,1.4,1.113-.364,2.658s-4.5,1.634-5.208.91a3.329,3.329,0,0,1-.859-1.256,1.871,1.871,0,0,0,1.162,2.445c1.8.646,3.722-.146,5.092-1.01s3.044-3.617,1.129-4.254a7.075,7.075,0,0,1-3.023-2.426",
    transform: "translate(-88.005 -43.866)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22217",
    "data-name": "Trac\\xE9 22217",
    d: "M112.325,61.2c6.445-1.056,18.009-5.305,23.539-2.79s8.484,5.138,22.728,2.055c8.187-1.958,20.912-1.291,23.355-1.672s-1.029-4.971-5.6-7.963c-2.4-12.618-5.583-25.371-17.01-28.639-6.078-4.914-24.868-5.924-33.088,4.279-8.122,3.949-15.23,16.007-12.631,29.852-1.134,1.077-3.568,5.213-1.291,4.878",
    transform: "translate(-62.788 -6.831)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22218",
    "data-name": "Trac\\xE9 22218",
    d: "M113.685,60.385c6.226-1.027,18.185-4.686,23.528-2.258s7.685,4.9,21.448,1.92c7.907-1.893,20.084-1.38,22.448-1.75s-.967-4.3-5.386-7.188c-2.321-12.2-5.387-24.517-16.429-27.677-5.873-4.741-24.031-5.721-31.969,4.136-7.853,3.817-14.714,15.465-12.207,28.841-1.094,1.042-3.636,4.295-1.431,3.976",
    transform: "translate(-63.313 -7.335)",
    fill: "#e3eaef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3719",
    "data-name": "Groupe 3719",
    transform: "translate(71.743 12.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3718",
    "data-name": "Groupe 3718",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22219",
    "data-name": "Trac\\xE9 22219",
    d: "M160.916,16.262c12.647,3.2,21.513,7.907,22.439,22.472,1.75.524-2.269-14.333-5.67-17.356s6.3,2.666,10.462,11.645S192.6,47.569,192.6,47.569s8.071,6.723,5.213,7.774,6.058,3.628,6.058,3.628.519-10.416.373-10.9-16.256-30.554-16.256-30.554l-18.928-6.4Z",
    transform: "translate(-130.49 -16.71)",
    fill: "#f2faff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3721",
    "data-name": "Groupe 3721",
    transform: "translate(22.242 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3720",
    "data-name": "Groupe 3720",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22221",
    "data-name": "Trac\\xE9 22221",
    d: "M181.777,23.481c7.547,6.172,8.385,11.218,9.762,22.644,1.037-2.969-.843-20.073-9.762-22.644",
    transform: "translate(-88.654 -8.628)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22222",
    "data-name": "Trac\\xE9 22222",
    d: "M134.568,29.018c9.532-.621,18.971,4.795,23.579,17.528.724,1.194,1.68,1.429,1.812.151s-3.247-13.5-8.971-17.758-6.7-8.025-16.421.078",
    transform: "translate(-71.307 -8.908)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22223",
    "data-name": "Trac\\xE9 22223",
    d: "M146.976,68.619c-5.856,3.385-13.169,4.916-18.239,4.525-.557-1.24,6.151-.113,18.239-4.525",
    transform: "translate(-69.153 -25.215)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22224",
    "data-name": "Trac\\xE9 22224",
    d: "M190.459,69.6c-8.226-.311-27.893,3.59-27.893,3.59s26.586-6.726,27.893-3.59",
    transform: "translate(-81.595 -25.268)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22225",
    "data-name": "Trac\\xE9 22225",
    d: "M185.015,133.54c-4.325,2.426-11.842,5.119-17.561,2.356a12.024,12.024,0,0,0,11.28,3.166c3.312-.624,5.967-3.671,6.281-5.521",
    transform: "translate(-83.391 -49.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22226",
    "data-name": "Trac\\xE9 22226",
    d: "M129.863,45.874a17.352,17.352,0,0,1-1.64,2.366,3.062,3.062,0,0,0-3.336,3.782c.772,3.992,6.234,2.38,5.543-1.359a2.9,2.9,0,0,0-1.4-2.029c.695-.937,1.321-1.912,2.086-2.779a2.455,2.455,0,0,0,.743.043,2.559,2.559,0,0,1,.745.041c.157.216-.473.826-.738,1.194-.319.44-.619.94-.872,1.31,1.934,3.161.359,6.661-2.469,7.4a3.948,3.948,0,0,1-4.809-2.88c-.781-2.717.346-5.386,2.71-6.126.875-.27,1.415-.065,1.75-.932a6.143,6.143,0,0,1,.832-.011,5.357,5.357,0,0,0,.856-.016",
    transform: "translate(-67.228 -16.85)",
    fill: "#0093d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22227",
    "data-name": "Trac\\xE9 22227",
    d: "M139.462,45.9c.024,1.137-.024,2.223.038,3.393a6.218,6.218,0,0,0,1.2.043,7.837,7.837,0,0,1,.043,1.018,18.51,18.51,0,0,1-2.369.07c-.025-1.5-.054-3,0-4.452.422-.119.67.044,1.094-.073",
    transform: "translate(-72.693 -16.866)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22228",
    "data-name": "Trac\\xE9 22228",
    d: "M145.314,50.255a4.97,4.97,0,0,1-1.027.089c-.052-.738.337-2.685-.671-2.353-.478.5-.132,1.564-.226,2.326a3.13,3.13,0,0,1-.954.07c-.13-1.559.013-2.926-.1-4.463.3.038.683-.037.968.027a5.282,5.282,0,0,1,.015,1.248,3.814,3.814,0,0,1,.984-.3c1.294.022.931,2.218,1.01,3.352",
    transform: "translate(-74.162 -16.876)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22229",
    "data-name": "Trac\\xE9 22229",
    d: "M152.613,45.768c.3.035.681-.04.97.016.113.307-.038.437.073.74-.4.119-.64-.014-1.023.078-.008-.278-.038-.57-.019-.835",
    transform: "translate(-77.936 -16.816)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22230",
    "data-name": "Trac\\xE9 22230",
    d: "M131.142,50.417c.3.521.281,1.964-.254,2.331a5.735,5.735,0,0,0-1.321.059,21.134,21.134,0,0,1,1.575-2.39",
    transform: "translate(-69.469 -18.526)",
    fill: "#0093d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22231",
    "data-name": "Trac\\xE9 22231",
    d: "M148.957,49.86c.813-.2.619-1.772-.287-1.478a.755.755,0,0,0,.287,1.478m1.6-.605c-.157,2.091-3.712,2.2-3.493-.351a1.755,1.755,0,0,1,3.493.351",
    transform: "translate(-75.894 -17.394)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22232",
    "data-name": "Trac\\xE9 22232",
    d: "M158.7,45.647c.359-.087.591.022.956-.065a6.55,6.55,0,0,1,.046.956.356.356,0,0,0,.387.062,6.807,6.807,0,0,1,.006.743l-.429.1a16.627,16.627,0,0,1,.04,2.383,6.719,6.719,0,0,0-.959.083c-.052-.821-.014-1.591-.038-2.4a.348.348,0,0,0-.386-.059c-.092-.27.057-.378-.057-.662l.467-.259a3.717,3.717,0,0,1-.032-.889",
    transform: "translate(-80.013 -16.75)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22233",
    "data-name": "Trac\\xE9 22233",
    d: "M152.6,47.419a4.9,4.9,0,0,0,1.027-.081c0,1.078-.035,2.128.054,3.263a5.054,5.054,0,0,1-1.029.094c-.032-1.1,0-2.166-.051-3.277",
    transform: "translate(-77.933 -17.395)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22234",
    "data-name": "Trac\\xE9 22234",
    d: "M156.768,48.227a1.611,1.611,0,0,1-1.242-.24l-.184.192c.395.521,1.167.254,1.426.8.762,1.591-2.309,2.588-2.42.576a3.8,3.8,0,0,0,.886-.057c.038.281.195.386.44.349l.187-.2c-.5-.581-1.542-.268-1.491-1.472.049-1.073,2.337-1.535,2.4.051",
    transform: "translate(-78.575 -17.343)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22235",
    "data-name": "Trac\\xE9 22235",
    d: "M130.335,53.848c.157.837.194,2.183-.5,2.642-.878.008-1.756.011-2.663.065-.068-.553.008-1.005-.049-1.556a16.772,16.772,0,0,1,2.366-.059,5.485,5.485,0,0,0,.843-1.091",
    transform: "translate(-68.572 -19.787)",
    fill: "#0093d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22236",
    "data-name": "Trac\\xE9 22236",
    d: "M184.758,134.188c-4.557,2.685-13.571,5.092-19.165,1.329-.621-.4.389-.77,2.231.143s8.031,2.555,16.44-2.18c.567-.335.9.232.494.708",
    transform: "translate(-82.64 -49.012)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22237",
    "data-name": "Trac\\xE9 22237",
    d: "M185.508,134.247a7.535,7.535,0,0,1-5.37,5.26c-2.123.594-10.942,1.6-12.687-3.612l.6.157s2,3.217,7.7,2.826,7.731-1.032,9.257-5.338a6.533,6.533,0,0,1,.494.708",
    transform: "translate(-83.39 -49.07)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22238",
    "data-name": "Trac\\xE9 22238",
    d: "M197.547,54.374c7.558.419,7,.424,7.258,1.772,1.27,6.635,3.8,6.165-7.537,6.726s.278-8.5.278-8.5",
    transform: "translate(-92.522 -19.98)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22239",
    "data-name": "Trac\\xE9 22239",
    d: "M147.181,64.959c-18.415,1.264-31.578,3.209-33.641,3.819s-1.065-6.413.148-7.053,31.029-5.254,34-4.614-.505,7.847-.505,7.847",
    transform: "translate(-63.143 -20.964)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22240",
    "data-name": "Trac\\xE9 22240",
    d: "M172.432,67.393c-4.984.543-6.872-2.226-7.553-5.022s.224-5.707,3.806-5.91,3.747,10.932,3.747,10.932",
    transform: "translate(-82.368 -20.746)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22241",
    "data-name": "Trac\\xE9 22241",
    d: "M191.94,59.437c-1.586,5.635-7.329,6.367-11.866,6.529s-9.417-.527-10.554-6.308-3.247-9.976,3.865-10.632,14.184-1.98,14.919,2.685c3.506,2.777,4.184,5.981,3.636,7.726",
    transform: "translate(-83.709 -17.762)",
    fill: "#353233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22242",
    "data-name": "Trac\\xE9 22242",
    d: "M191.205,56.971c-5.265.478-10.006,3.115-9.7,5.462s.552,3.366,5.025,3.487,8.265-2.285,9.068-4.635-1.821-4.268-4.39-4.314",
    transform: "translate(-88.548 -20.935)",
    fill: "#fff1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22243",
    "data-name": "Trac\\xE9 22243",
    d: "M185.69,55.381c-4.508.832-10.424,3.619-10.924,7.644-.07,1.362,1.267.23,1.464-.626s.464-4.152,9.46-7.018",
    transform: "translate(-86.077 -20.35)",
    fill: "#646363"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3723",
    "data-name": "Groupe 3723",
    transform: "translate(106.851 30.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3722",
    "data-name": "Groupe 3722",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22244",
    "data-name": "Trac\\xE9 22244",
    d: "M189.441,52.513c-3.76-2.177-3.668-1.8-5.446-1.9a9.6,9.6,0,0,0-2.28.018,6.485,6.485,0,0,1,2.953-1.126c1.588-.116-.464-1.367-3.034-1.951s-11.672.695-13.168,1.192-1.788,2.59-2.207,3.636-6.451-3.274-1.273-5.208,24.438-3,24.438-3Z",
    transform: "translate(-166.326 -46.807)",
    fill: "#646363"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3725",
    "data-name": "Groupe 3725",
    transform: "translate(22.242 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3724",
    "data-name": "Groupe 3724",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22246",
    "data-name": "Trac\\xE9 22246",
    d: "M190.288,64.066c.113,1.331-.395,2.464-1.132,2.526s-1.432-.967-1.545-2.3.394-2.464,1.135-2.526,1.429.967,1.542,2.3",
    transform: "translate(-90.792 -22.696)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3727",
    "data-name": "Groupe 3727",
    transform: "translate(71.45 36.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3726",
    "data-name": "Groupe 3726",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22247",
    "data-name": "Trac\\xE9 22247",
    d: "M118.453,69.053c-5.313-3.039-3.177-13.774-1.418-15.419s-13.487,6.532-13.487,6.532l-.289,11.3Z",
    transform: "translate(-109.01 -55.714)",
    fill: "#292928"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3729",
    "data-name": "Groupe 3729",
    transform: "translate(1.043 37.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3728",
    "data-name": "Groupe 3728",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22249",
    "data-name": "Trac\\xE9 22249",
    d: "M270.318,128.082c.84,9.662,4.619,30.675,14.287,36.561s18.909-8.406,18.909-8.406L276.62,122.2Z",
    transform: "translate(-99.991 -82.664)",
    fill: "#536551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22250",
    "data-name": "Trac\\xE9 22250",
    d: "M243.812,138.043c1.261,8.828,2.939,29.838,10.087,37.4s-15.13,8.406-15.13,8.406-12.185-25.634-9.246-39.922,14.29-5.883,14.29-5.883",
    transform: "translate(-84.832 -87.584)",
    fill: "#536551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22251",
    "data-name": "Trac\\xE9 22251",
    d: "M279.613,88.269c1.264,15.546,12.747,43.279,21.853,42.442s26.478-75.64,26.478-75.64l-43.285-4.622Z",
    transform: "translate(-103.406 -56.299)",
    fill: "#1b2264"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3731",
    "data-name": "Groupe 3731",
    transform: "translate(1.043 35.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3730",
    "data-name": "Groupe 3730",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22253",
    "data-name": "Trac\\xE9 22253",
    d: "M277.812,174.153a80.686,80.686,0,0,1-5.189,10.773c3.788-1.767,6.988-3.344,9.149-4.43a29.456,29.456,0,0,1-3.96-6.342",
    transform: "translate(-100.838 -99.078)",
    fill: "#948a87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22254",
    "data-name": "Trac\\xE9 22254",
    d: "M272.558,172.819c-3.633,1.537-8.274,3.163-13.166,4.733a37.146,37.146,0,0,0,3.714,9c1.623-.724,3.182-1.437,4.654-2.12a80.731,80.731,0,0,0,5.191-10.773c-.135-.278-.267-.559-.394-.843",
    transform: "translate(-95.976 -98.588)",
    fill: "#574915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22255",
    "data-name": "Trac\\xE9 22255",
    d: "M226.429,187.59c-7.256,2.037-13.142,3.541-14.657,3.925a63.532,63.532,0,0,1,1.448,10.986c4.692-.354,10.8-2.067,17.1-4.32-1.134-2.745-2.569-6.464-3.889-10.591m-12.934,17.466h0l-.116.024c.03.586.062,1.178.087,1.777l.17-.04c-.04-.589-.087-1.178-.14-1.761m-1.726,1.483c-.008.246-.019.492-.03.743a.09.09,0,0,0,.03-.008v-.735",
    transform: "translate(-78.465 -104.016)",
    fill: "#574915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22256",
    "data-name": "Trac\\xE9 22256",
    d: "M211.57,193.793l-.381.094s.8,4.02.378,14.93c0,.246,0,.492,0,.738.14-.035.729-.178,1.694-.419-.025-.6-.057-1.191-.087-1.777a5,5,0,0,1-.821.119c-.681,0,.094-.683.094-2.66.189-.008.376-.022.567-.035a63.355,63.355,0,0,0-1.448-10.988",
    transform: "translate(-78.263 -106.295)",
    fill: "#100f1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22257",
    "data-name": "Trac\\xE9 22257",
    d: "M283.466,145.38c-1.11,0,4.741,11.04,3.927,13.071-.789,1.226-3.457,2.707-7.191,4.284.13.286.263.567.395.845a29.36,29.36,0,0,0,3.96,6.34c1.886-.948,2.98-1.526,2.98-1.526a61.075,61.075,0,0,0,9.954-4.2,22.165,22.165,0,0,1-4.952-5.362c-.035.014-.07.025-.1.035a1.893,1.893,0,0,1-.54.081c-3.914,0-6.677-12.725-8.284-13.528a.324.324,0,0,0-.146-.043",
    transform: "translate(-103.623 -88.505)",
    fill: "#363f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22258",
    "data-name": "Trac\\xE9 22258",
    d: "M250.416,180.3c-5.167,1.659-10.613,3.253-15.454,4.611,1.321,4.127,2.755,7.844,3.889,10.591,5.184-1.853,10.5-4.07,15.278-6.2a37.055,37.055,0,0,1-3.714-9",
    transform: "translate(-86.999 -101.338)",
    fill: "#363f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22259",
    "data-name": "Trac\\xE9 22259",
    d: "M325.234,73.617c-.413.183-.829.351-1.248.5-.051.027-.1.057-.151.087a16.66,16.66,0,0,1-3.082.759c.77,21.837-16.793,55.77-21.045,57.5a22.057,22.057,0,0,0,4.952,5.362c2.377-1.326,4.44-2.872,5.173-4.487,5.654-6.029,13.787-50.6,15.4-59.722",
    transform: "translate(-110.79 -62.135)",
    fill: "#1a1c40"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22261",
    "data-name": "Trac\\xE9 22261",
    d: "M190.24,224.594l2.215-.319-.144-1.021-1.215.175-.516-3.59-1,.149Z",
    transform: "translate(-69.279 -80.782)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3733",
    "data-name": "Groupe 3733",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3732",
    "data-name": "Groupe 3732",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22262",
    "data-name": "Trac\\xE9 22262",
    d: "M194.156,224.045l.883-.124-.273-1.9c-.022-.165-.1-.673.4-.743.47-.07.548.476.572.64l.268,1.858.88-.127-.275-1.9a1.865,1.865,0,0,0-.454-1.21,1.014,1.014,0,0,0-.859-.257.8.8,0,0,0-.694.54l-.03.051-.221-1.559-.859.122Z",
    transform: "translate(-71.761 -80.589)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22263",
    "data-name": "Trac\\xE9 22263",
    d: "M199.575,222.05a.739.739,0,1,1,1.434-.208.74.74,0,1,1-1.434.208m-.9.13a1.643,1.643,0,1,0,1.348-2.075,1.72,1.72,0,0,0-1.348,2.075",
    transform: "translate(-73.658 -80.873)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22264",
    "data-name": "Trac\\xE9 22264",
    d: "M203.547,219.154l.5,3.471.88-.124-.5-3.474Zm-.164-1.137.111.775.88-.127-.108-.772Z",
    transform: "translate(-74.352 -80.067)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3735",
    "data-name": "Groupe 3735",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3734",
    "data-name": "Groupe 3734",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22265",
    "data-name": "Trac\\xE9 22265",
    d: "M207.787,220.14a1.042,1.042,0,0,0-1.226-.921,1.137,1.137,0,0,0-.942,1.326.986.986,0,0,0,.772.877c.378.1.762.03.808.376.032.221-.13.308-.278.33a.325.325,0,0,1-.351-.319l-.81.116a1.092,1.092,0,0,0,1.264.98,1.181,1.181,0,0,0,1.046-1.359c-.1-.7-.591-.867-1.116-.956-.243-.046-.464-.019-.5-.3a.277.277,0,0,1,.211-.322c.259-.037.306.222.321.295Z",
    transform: "translate(-76.211 -80.549)",
    fill: "#161615"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22266",
    "data-name": "Trac\\xE9 22266",
    d: "M209.353,217.144l.162,1.135-.386.054.111.778.386-.059.389,2.7.881-.121-.389-2.7.386-.052-.113-.778-.378.054-.168-1.14Z",
    transform: "translate(-76.463 -79.743)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22267",
    "data-name": "Trac\\xE9 22267",
    d: "M180.156,230.552l2.35-.34.557-1.148.259,1.8,0,0-.411.816-2.545.368Z",
    transform: "translate(-65.817 -84.172)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22268",
    "data-name": "Trac\\xE9 22268",
    d: "M182.195,227.988l1.256-.181.289-.6h0l-.256-1.8Z",
    transform: "translate(-66.566 -82.829)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3737",
    "data-name": "Groupe 3737",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3736",
    "data-name": "Groupe 3736",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22269",
    "data-name": "Trac\\xE9 22269",
    d: "M184.482,220.094l-1.35,2.815.005.005a5.534,5.534,0,0,1,1.286,2.766c.367,2.566-1.129,4.895-3.342,5.217s-4.306-1.5-4.673-4.065,1.07-4.906,3.279-5.227l.473-.891,1.586-.23-1.286,2.583h-.013a2.328,2.328,0,0,0-.513.013,3.26,3.26,0,1,0,3.209,2.8,3.357,3.357,0,0,0-1.745-2.553l.011,0,1.5-3.009Z",
    transform: "translate(-65.462 -80.876)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22270",
    "data-name": "Trac\\xE9 22270",
    d: "M64.852,189.447c6.27,1.6,12.963,13.439,14.511,19.06.932,2.793,1.053.854,1.105-1.721s-10.727-19.776-15.616-17.339",
    transform: "translate(-24.49 -69.527)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22271",
    "data-name": "Trac\\xE9 22271",
    d: "M244.258,138.17c-1.343.457-7.561,2.953-14.387,5.543,4.527-1.548,8.525-3,11.126-4.157,1.2-.535,2.277-1,3.261-1.386M206.4,149.626c1.137.089,2.239.219,3.274.373.381-.011.721-.016,1.018-.016.151,0,.292,0,.419.005a40.515,40.515,0,0,0-4.711-.362",
    transform: "translate(-76.503 -50.772)",
    fill: "#7fcef6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22272",
    "data-name": "Trac\\xE9 22272",
    d: "M239.85,139.422c-.5.183-1.005.38-1.5.594-1.445.612-5.306,1.972-9.895,3.538.057.468.119.949.181,1.44,5.035-1.671,9.814-3.108,11.467-3.438l.073-.016c-.119-.727-.23-1.432-.324-2.118m-26.637,9.238c-3.7,1.223-6.564,2.163-7.474,2.461,2.244.486,3.69.94,3.69.94s-5.475-.584-11.154-.584c-4.184,0-8.479.316-10.767,1.419a6.309,6.309,0,0,1-.81.6v.005c0,.147-.108.241-.383.241a.574.574,0,0,1,.043-.046,5.825,5.825,0,0,1-.548.262,3.038,3.038,0,0,0,.505,1.467,27.4,27.4,0,0,1,9.781-1.469c1.888,0,3.736.1,5.446.195s3.277.194,4.606.194a12.954,12.954,0,0,0,2.437-.181,32.7,32.7,0,0,0,4.684-1.237c-.062-.862-.094-1.71-.1-2.539,0-.583.013-1.159.043-1.723m-10.086,1.782c-.3,0-.638.006-1.019.016.9.132,1.748.281,2.526.435l-1.091-.445c-.127,0-.268-.006-.416-.006",
    transform: "translate(-68.937 -51.232)",
    fill: "#fff096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22273",
    "data-name": "Trac\\xE9 22273",
    d: "M248.066,137.906a3.238,3.238,0,0,0-1.018.149.26.26,0,0,0-.051.019c-.984.389-2.064.848-3.263,1.386-2.6,1.161-6.6,2.609-11.124,4.157-7.306,2.774-15.307,5.659-18.76,6.272l1.089.445c.389.076.757.154,1.108.23.908-.3,3.776-1.24,7.474-2.461.014-.278.033-.551.057-.821,6.2-2.037,13.263-4.628,15.054-5.287.04.327.084.659.127,1,4.589-1.567,8.449-2.926,9.895-3.538.5-.214,1-.411,1.5-.595-.027-.192-.057-.383-.081-.57a5.908,5.908,0,0,0-2.007-.389",
    transform: "translate(-79.241 -50.675)",
    fill: "#3c385c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22274",
    "data-name": "Trac\\xE9 22274",
    d: "M187.51,160.721a4.531,4.531,0,0,0-.826.5.332.332,0,0,1,.013.1,6.559,6.559,0,0,0,.813-.6m-1.053.067c-.162.063-.33.125-.495.187a1.837,1.837,0,0,0-.151.8c.187-.078.37-.164.546-.259a2.77,2.77,0,0,1,.327-.3,1.429,1.429,0,0,0-.227-.433",
    transform: "translate(-68.937 -59.058)",
    fill: "#685d67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22275",
    "data-name": "Trac\\xE9 22275",
    d: "M271.116,138.521c.024.187.054.378.081.57.095.683.206,1.391.324,2.118,2.658-.562,1.45-1.993-.405-2.688",
    transform: "translate(-100.284 -50.901)",
    fill: "#879080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22276",
    "data-name": "Trac\\xE9 22276",
    d: "M244.222,144.371c-1.791.659-8.855,3.249-15.054,5.286-.025.27-.04.546-.057.822-.03.564-.046,1.14-.043,1.723,0,.829.035,1.677.1,2.539,1.6-.6,2.229-1.221.778-1.7-1.529-.513,6.835-3.649,14.587-6.226q-.093-.738-.181-1.44c-.044-.343-.084-.675-.127-1",
    transform: "translate(-84.833 -53.05)",
    fill: "#879080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22277",
    "data-name": "Trac\\xE9 22277",
    d: "M185.919,158.047c8.528-4.49,23.233.135,23.233.135s-19.749-2.1-23.114,1.68c1.261,0-.978-1.967-.978-1.967Z",
    transform: "translate(-68.662 -57.355)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22278",
    "data-name": "Trac\\xE9 22278",
    d: "M213.849,148.939c10.214-3.476,23.833-7.726,29.884-10.432s9.081-3.476,11.729-3.09l2.65.386a45.738,45.738,0,0,0-9.46,2.7c-4.538,1.934-32.912,11.2-32.912,11.2Z",
    transform: "translate(-79.241 -49.726)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22279",
    "data-name": "Trac\\xE9 22279",
    d: "M213.809,161.99c7.139-1.259,41.6-12.747,50.006-19.468C271.8,140,275.719,138.878,279.5,133s9.527-28.015,15.13-62.472c-.838-.424-1.118.276-1.118.276s-9.387,54.627-15.689,61.35c-2.1,4.628-15.127,8.687-15.127,8.687s-33.763,17.788-49.727,18.633c0,2.518-1.262,2.936.843,2.518",
    transform: "translate(-78.778 -25.865)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22280",
    "data-name": "Trac\\xE9 22280",
    d: "M283.6,110.949c.84-2.8,7.282-14.009,9.244-19.049s10.645-24.093,10.364-26.615c-.84.281-10.083,22.412-10.083,22.412s-14.849,26.335-9.525,23.252",
    transform: "translate(-104.447 -23.99)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22281",
    "data-name": "Trac\\xE9 22281",
    d: "M160.713,159.089c-2.361-3.827-4.8-6.132-7.828-5.924-1.283.089-5.564-1.791-10.5-3.676-6.724-2.564-14.657-5.13-17.885-2.715-5.6,4.187-2.409,9.1-2.409,9.1l8.439-4.387,20.945,5.962,4.387,2.925Z",
    transform: "translate(-45.189 -53.578)",
    fill: "#1b2264"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22282",
    "data-name": "Trac\\xE9 22282",
    d: "M135.527,176.005s11.764,6.048,18.271,4.711,11.3-6.537,11.3-6.537l-.489-5.129L134.2,171.673Z",
    transform: "translate(-49.972 -62.119)",
    fill: "#fce0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22283",
    "data-name": "Trac\\xE9 22283",
    d: "M158.366,147.208c-1.986-3.03-3.46-5.97-3.034-7.139s2.234-8.014,3.48-10.13S137.75,94.774,137.75,94.774l-3.512,6.075-2.939,1.469a29.9,29.9,0,0,1,1.148,3.723c.208,1.256.4,25.827-9.119,31.175.948,10.073,22.177,20.135,35.038,9.992",
    transform: "translate(-45.978 -34.826)",
    fill: "#fce0cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3739",
    "data-name": "Groupe 3739",
    transform: "translate(78.393 59.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3738",
    "data-name": "Groupe 3738",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22284",
    "data-name": "Trac\\xE9 22284",
    d: "M172.85,160.947l.216.176c.3-.016.615-.04.927-.07.008-.03.019-.059.029-.089l-.189,0c-.326,0-.653-.008-.982-.019",
    transform: "translate(-141.525 -119.093)",
    fill: "#cbb19f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3741",
    "data-name": "Groupe 3741",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3740",
    "data-name": "Groupe 3740",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22286",
    "data-name": "Trac\\xE9 22286",
    d: "M175.952,151.746c-4.354,10.314-4.471,14.125-3.449,17.855a30.733,30.733,0,0,1,.643-7.139s1.205,4.606,2.979,6.38l.913-1.456s-3.3-3.7-3.228-6.367,2.9-9.325,2.9-9.325Z",
    transform: "translate(-63.853 -55.742)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22287",
    "data-name": "Trac\\xE9 22287",
    d: "M131.1,106.99c2.717,6.278-.151,25.232-4.83,30.878l-3.2,3.266.719,1.215s4.611-4.754,6.262-10.189,3.941-18.147,2.18-25.248a1.108,1.108,0,0,0-1.135.078",
    transform: "translate(-45.883 -39.237)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22288",
    "data-name": "Trac\\xE9 22288",
    d: "M152.132,170.89c-6.426,3.3-11.515,1.178-16.507-2.277s-14.473-12.239-14.59-14.832.765-3.6.765-3.6l3.566-3.417a9.127,9.127,0,0,0-7.837,4.854c-2.512,4.927,3.155,20.883,8.874,26.57,2.134-4.9,7.78-5.673,12-5.206s6.74,1.243,9.914.454l3.182-.791s4.368-2.774,6.694,3.339c4.795-4.9,3.39-14.111.076-18.066l-4.082,1.424s2.774,4.368.738,7.931Z",
    transform: "translate(-43.622 -53.929)",
    fill: "#1b2264"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22289",
    "data-name": "Trac\\xE9 22289",
    d: "M177.381,171.105l-2.634-7.369,3.474-1.569Z",
    transform: "translate(-63.829 -59.59)",
    fill: "#1b2264"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3743",
    "data-name": "Groupe 3743",
    transform: "translate(78.393 59.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3742",
    "data-name": "Groupe 3742",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22290",
    "data-name": "Trac\\xE9 22290",
    d: "M132.107,139.27c-.4,1.9-.816,3.56-1.2,4.83a28.2,28.2,0,0,1-5.508,9.357,33.408,33.408,0,0,0,2.447,2.858c.953-2.547,4.473-7.661,6.051-7.661a.6.6,0,0,1,.54.326c3.452,7.847,19.9,10.665,20.505,10.765a26.9,26.9,0,0,1,1.121-5.141c-.089,0-.181,0-.273,0a17.465,17.465,0,0,1-5.872-.992c-5.938-2.1-14.754-8.919-17.809-14.346m18.23,13.044a9.625,9.625,0,0,0,4.106.865c-.268-.1-.551-.206-.856-.324a26.092,26.092,0,0,1-3.249-.54",
    transform: "translate(-124.088 -111.128)",
    fill: "#d8bdac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22291",
    "data-name": "Trac\\xE9 22291",
    d: "M169.962,160.747q.458.178.856.324c.092,0,.186,0,.278,0q.45,0,.907-.025l-.216-.175c-.6-.021-1.21-.065-1.826-.127",
    transform: "translate(-140.464 -119.02)",
    fill: "#b09689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22292",
    "data-name": "Trac\\xE9 22292",
    d: "M173.454,163.505c-.076,0-.154,0-.232.006a26.944,26.944,0,0,0-1.121,5.14l.016,0Z",
    transform: "translate(-141.25 -120.033)",
    fill: "#97786c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22293",
    "data-name": "Trac\\xE9 22293",
    d: "M131.656,138.563c-1.151,5.74-3.206,11.418-6.831,14.128.111.162.23.332.359.5a28.1,28.1,0,0,0,5.511-9.357c.386-1.27.8-2.934,1.2-4.829-.083-.149-.164-.3-.24-.446",
    transform: "translate(-123.878 -110.868)",
    fill: "#97786c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22294",
    "data-name": "Trac\\xE9 22294",
    d: "M124.275,160.9a8.236,8.236,0,0,1-.948.616,8.61,8.61,0,0,0,.559,2.3,5.319,5.319,0,0,0,2.472,1.283.57.57,0,0,0,.6-.451c.035-.119.078-.245.13-.381a34.164,34.164,0,0,1-2.45-2.858c-.13-.176-.249-.343-.359-.508",
    transform: "translate(-123.328 -119.074)",
    fill: "#1b2158"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3745",
    "data-name": "Groupe 3745",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3744",
    "data-name": "Groupe 3744",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22296",
    "data-name": "Trac\\xE9 22296",
    d: "M208.959,77.879c.24,3.5-.395,12.38-.395,12.38s.96,2.085,2.645,1.085a5.536,5.536,0,0,0,2.256-2.35s-2.126,1.027-2.485-.929.7-2.683,1.4-2.075l.7.614s.259-2.655-1.337-3.423.394-.689.383-3.984a7.212,7.212,0,0,0-1.661-4.935l-1.078.294Z",
    transform: "translate(-77.298 -27.288)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22297",
    "data-name": "Trac\\xE9 22297",
    d: "M128.978,120.423l1,1.691-1.829-.972s-5.63,2.941-6.861-5.324c-2.884-5.972-2.242-8.768,2.228-10.835-.357-1.95,2.9-8.768,2.9-8.768l7.369,17.5Z",
    transform: "translate(-44.585 -35.355)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22298",
    "data-name": "Trac\\xE9 22298",
    d: "M175.812,72.767l.532,7.652s-1.3,25.581-2.169,28.936-3.922,16.311-13.436,18.512-23.955-.1-31.075-17.182c-.724,2.25-5.205,1.385-6-.538s-4.73-8.387-2.647-10.065.47-2.674,2.874-2.842,1.65-11.1,1.65-11.1l-.289-10.524Z",
    transform: "translate(-44.909 -26.739)",
    fill: "#fce0cb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3747",
    "data-name": "Groupe 3747",
    transform: "translate(76.552 46.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3746",
    "data-name": "Groupe 3746",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22299",
    "data-name": "Trac\\xE9 22299",
    d: "M199.358,114.495c-.292.046-.589.089-.889.124,0,.068-.008.138-.011.206.108.022.216.046.321.065-.111.056-.224.108-.34.156a33.606,33.606,0,0,1-3.112,10.189c-.226,3.091-4.136,13.25-8.782,15.989l.975.5a15.044,15.044,0,0,0,3.641-2.026c2.488-2.15,6.189-15.369,6.189-15.369a28.667,28.667,0,0,0,2.007-9.833",
    transform: "translate(-144.717 -88.099)",
    fill: "#fff3ea"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3749",
    "data-name": "Groupe 3749",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3748",
    "data-name": "Groupe 3748",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22301",
    "data-name": "Trac\\xE9 22301",
    d: "M138.782,80.3a27.525,27.525,0,0,0-3.571.262l.319,2.007a39.807,39.807,0,0,1-1.018,10.622c-1.35,5.8,1.173,13.757,1.173,13.757l-1.715.559-.046-.657a10.339,10.339,0,0,0-1.872-4.184l-.591,1.3c1.337,1.251,1.753,3.62,3.182,10.078,1.467,6.618,8.058,11.21,13.423,14.217-8.287-10.5-6.647-16.543-6.621-22.267.281.016.614.025.989.025,4.344,0,14.428-1.032,15.511-2.929,1.178-2.058,6.316-3.955,6.972-4,.029,0,.054,0,.081,0,.54,0,.186.491.494,1.937.195.91.686,1.561,1.024,1.561.224,0,.381-.292.332-.994a8.672,8.672,0,0,0-.384-2.388s3.658,3.973,8.393,3.973a8.3,8.3,0,0,0,3.341-.7c.008-.073.014-.146.019-.221-.194-.04-.389-.087-.583-.135a30.026,30.026,0,0,1-3.085.17,11.508,11.508,0,0,1-1.672-.094c-1.9-.287-4.66-3.587-5.438-7.023a4.632,4.632,0,0,0-1.748-.3,11.692,11.692,0,0,0-3.541.667,15.636,15.636,0,0,1-3.074,5.875c-1.632,1.618-10.467,2.423-15.027,2.423-.757,0-1.393-.021-1.861-.067-3.3-.311-6.78-5.068-5.162-9.336,1.426-3.774,1.667-4.346,5.37-4.938-.216-1.464-.446-3.973.483-4.038a.7.7,0,0,1,.076,0c.6,0,2.139.351,4.027.7a34.981,34.981,0,0,0,6.107.7,10.63,10.63,0,0,0,2.826-.326,59.752,59.752,0,0,1,14.662-2.378c.184,0,.37,0,.554.006.392.008.772.013,1.137.013,3.555,0,5.945-.44,6.575-2.437a68.835,68.835,0,0,0-12.872,1.4,51.775,51.775,0,0,1-10.751,1.4c-5.675,0-8.239-1.75-11.977-3.455a10.878,10.878,0,0,0-4.46-.783",
    transform: "translate(-48.966 -29.505)",
    fill: "#d8bdac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22302",
    "data-name": "Trac\\xE9 22302",
    d: "M205.365,115.015c-.006.073-.011.149-.019.221.116-.049.23-.1.343-.157-.108-.018-.216-.043-.324-.065",
    transform: "translate(-76.116 -42.263)",
    fill: "#ddcfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22303",
    "data-name": "Trac\\xE9 22303",
    d: "M126.572,117.3c-1.251,0-1.472,2.29-1.037,3.347l.524,1.28s-.233-.311-.519-.783c.7,2.185,2.1,4.516,3.927,4.516a2.354,2.354,0,0,0,.864-.17c-1.175-5.367-1.07-6.666-2.807-7.839a1.765,1.765,0,0,0-.953-.351",
    transform: "translate(-46.714 -43.104)",
    fill: "#d8bdac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22304",
    "data-name": "Trac\\xE9 22304",
    d: "M179.217,80.527c-.691,9.055-2.01,12.223-1.78,15.5s.035,13.185-1.956,16.175c-.5,5.532-4.625,15.7-8.66,17.739s-10.67,4.482-17.428,2.088-17.234-10.886-18.723-16.493c-2.123-8.423-1.575-10-3.644-11.4s-2.52,1.713-1.991,3l.524,1.281s-4.362-5.851,1.386-5.368c2.936,1.116,3.031,2.428,4.943,11.081s12.607,13.846,17.847,16.559,15.948-1.324,18.436-3.474,6.189-15.37,6.189-15.37a29.912,29.912,0,0,0,1.882-13.973l.216-6.386s.457-9.26-.476-10.073,3.234-.886,3.234-.886",
    transform: "translate(-46.215 -29.59)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22305",
    "data-name": "Trac\\xE9 22305",
    d: "M165.178,134.89a2.227,2.227,0,0,0-.757,1.81s-2-1.948.757-1.81",
    transform: "translate(-60.82 -49.564)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22306",
    "data-name": "Trac\\xE9 22306",
    d: "M185.6,144.522a12.878,12.878,0,0,1-3.46.789s1.991,3.378,3.46-.789",
    transform: "translate(-67.589 -53.106)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22307",
    "data-name": "Trac\\xE9 22307",
    d: "M128.046,117.456c-.951,2.153,1.767,6.472,3.187,6.372l.624,1.056s-6.429-2.413-4.849-8.126c1.45.34,1.037.7,1.037.7",
    transform: "translate(-47.238 -42.904)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22308",
    "data-name": "Trac\\xE9 22308",
    d: "M131.883,130.946c-2.785,1.07-4.573.646-4.733-.111.778.164,4.9-.562,4.852-1.326s-.119,1.437-.119,1.437",
    transform: "translate(-47.382 -47.53)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22309",
    "data-name": "Trac\\xE9 22309",
    d: "M179.379,156.358c1.369-.867,2.736-4.915,2.361-7.193.819-.829,1.788-1.115,2.137-.81s.659,6.324,1.98,6.345-3.6,5.082-6.478,1.659",
    transform: "translate(-66.574 -54.47)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22310",
    "data-name": "Trac\\xE9 22310",
    d: "M120.48,99.062c2.814-.629,2.306,1.6,3.725,3.039a10.051,10.051,0,0,1,2.3,4.676l.048.657,1.713-.559s-2.523-7.955-1.17-13.757a39.854,39.854,0,0,0,1.018-10.624l-.381-2.388-13.078,1.564s.051,7.031-1.64,8.028l-1.686.994s4.211.586,4.778-.77c-2.349,4.119-4.829,3.19-4.829,3.19s2.385,2.693,4.668.778c.161,2.4-1.524,3.4-2.635,3.258l-1.1-.145a3.077,3.077,0,0,0,3.617,1.51c-.565,1.356-1.569,2.741-1.024,4.244.738-2.029,2.3-1.694,2.3-1.694s1.267-.757,3.377-2",
    transform: "translate(-41.55 -29.435)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22311",
    "data-name": "Trac\\xE9 22311",
    d: "M128.946,109.293c-1.734.34-4.206,2.709-4.206,2.709l-.378.905s-1.1-3.22,1.416-4.933,3.168,1.318,3.168,1.318",
    transform: "translate(-46.269 -39.484)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22312",
    "data-name": "Trac\\xE9 22312",
    d: "M128.572,93.478c-1.116,1.82-.519,2.75-.519,2.75s-11.667-2.1-12.882-4.338l.054-1.75s9.152,4.211,13.347,3.339",
    transform: "translate(-42.98 -33.122)",
    fill: "#003844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22313",
    "data-name": "Trac\\xE9 22313",
    d: "M164.363,103.672c-2.636-3.112-10.24-1.924-10.451,1.383s7.909,3.188,9.959,1.07.491-2.453.491-2.453",
    transform: "translate(-57.215 -37.43)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22314",
    "data-name": "Trac\\xE9 22314",
    d: "M164.109,104.351c-2.218-2.515-8.668-1.535-8.857,1.146s6.691,2.563,8.436.84.421-1.986.421-1.986",
    transform: "translate(-57.707 -37.81)",
    fill: "#ecf8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22315",
    "data-name": "Trac\\xE9 22315",
    d: "M193.334,102.193c1.912-3.173,8.7-3.038,9.3-.035s-6.51,3.9-8.56,2.221-.735-2.186-.735-2.186",
    transform: "translate(-71.549 -36.694)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22316",
    "data-name": "Trac\\xE9 22316",
    d: "M194.456,102.732c1.626-2.577,7.38-2.483,7.88-.051s-5.527,3.177-7.263,1.815-.616-1.764-.616-1.764",
    transform: "translate(-71.983 -37.05)",
    fill: "#ecf8fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22317",
    "data-name": "Trac\\xE9 22317",
    d: "M165.868,105.71a1.66,1.66,0,1,1-1.737-1.31,1.542,1.542,0,0,1,1.737,1.31",
    transform: "translate(-60.403 -38.361)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22318",
    "data-name": "Trac\\xE9 22318",
    d: "M204.017,103.694a1.453,1.453,0,1,1-1.518-1.142,1.351,1.351,0,0,1,1.518,1.142",
    transform: "translate(-74.573 -37.682)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22319",
    "data-name": "Trac\\xE9 22319",
    d: "M165.461,92.747c-.57-1.937-14.454-2.509-15.554.64s14.789.954,14.789.954Z",
    transform: "translate(-55.725 -33.497)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22320",
    "data-name": "Trac\\xE9 22320",
    d: "M202.53,91.669c-.667-1.887-11.5-1.612-12,1.586s11.582.038,11.582.038Z",
    transform: "translate(-70.667 -33.252)",
    fill: "#372e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22321",
    "data-name": "Trac\\xE9 22321",
    d: "M165.371,99.493c-10.262.206-13.822-.024-15.168.816s-2.123,5.005.073,6.953c.854.765,2.534,1.032,4.441,1.032a38.112,38.112,0,0,0,8.331-1.121c2.977-.751,4.076-7.191,2.323-7.68M156.8,106.77c-2.5,0-4.846-.786-4.733-2.585.125-1.975,2.885-3.2,5.651-3.2a6.28,6.28,0,0,1,4.8,1.813s1.555.33-.492,2.45c-.934.967-3.133,1.518-5.227,1.518",
    transform: "translate(-55.374 -36.56)",
    fill: "#ebe8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22322",
    "data-name": "Trac\\xE9 22322",
    d: "M159.566,101.862c-2.769,0-5.527,1.218-5.654,3.192-.114,1.8,2.236,2.585,4.732,2.585,2.1,0,4.292-.551,5.227-1.516,2.05-2.123.491-2.452.491-2.452a6.281,6.281,0,0,0-4.8-1.81m-.835,5.337c-2.1,0-4.074-.629-3.971-2.083.111-1.6,2.469-2.6,4.822-2.6a5.4,5.4,0,0,1,4.036,1.456s1.321.264-.421,1.986c-.8.789-2.679,1.242-4.465,1.242",
    transform: "translate(-57.215 -37.43)",
    fill: "#c3bcb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22323",
    "data-name": "Trac\\xE9 22323",
    d: "M160.076,102.9c-2.353,0-4.711.994-4.822,2.6-.1,1.45,1.867,2.08,3.971,2.08,1.786,0,3.666-.451,4.465-1.242,1.742-1.721.419-1.986.419-1.986a5.4,5.4,0,0,0-4.033-1.454m-.47,3.382a1.518,1.518,0,0,1-1.6-1.31,1.54,1.54,0,0,1,1.54-1.535,1.245,1.245,0,0,1,.137-.005,1.7,1.7,0,0,1,1.254.524,1.794,1.794,0,0,1,.5-.1,1.019,1.019,0,0,1,.133-.006,1.518,1.518,0,0,1,1.6,1.313,1.545,1.545,0,0,1-1.537,1.537c-.046,0-.089,0-.132,0a1.7,1.7,0,0,1-1.264-.527,1.773,1.773,0,0,1-.5.1c-.046,0-.089.006-.132.006",
    transform: "translate(-57.708 -37.81)",
    fill: "#e2f4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22324",
    "data-name": "Trac\\xE9 22324",
    d: "M164.465,104.4c-.046,0-.089,0-.132.006a1.9,1.9,0,0,0-.5.1,1.311,1.311,0,0,1,.343.786,1.46,1.46,0,0,1-1.04,1.431,1.71,1.71,0,0,0,1.266.527c.044,0,.087,0,.13,0a1.548,1.548,0,0,0,1.54-1.537,1.523,1.523,0,0,0-1.6-1.313",
    transform: "translate(-60.605 -38.361)",
    fill: "#7a7985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22325",
    "data-name": "Trac\\xE9 22325",
    d: "M161.274,103.738c-.046,0-.092,0-.138.006a1.542,1.542,0,0,0-1.54,1.534,1.515,1.515,0,0,0,1.6,1.31c.043,0,.086,0,.132,0a1.9,1.9,0,0,0,.5-.105,1.283,1.283,0,0,1-.343-.786,1.46,1.46,0,0,1,1.037-1.432,1.7,1.7,0,0,0-1.253-.524",
    transform: "translate(-59.304 -38.119)",
    fill: "#e7f6fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22326",
    "data-name": "Trac\\xE9 22326",
    d: "M163.628,104.568a1.462,1.462,0,0,0-1.04,1.431,1.285,1.285,0,0,0,.345.786,1.459,1.459,0,0,0,1.037-1.431,1.283,1.283,0,0,0-.343-.786",
    transform: "translate(-60.403 -38.424)",
    fill: "#aaafba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22327",
    "data-name": "Trac\\xE9 22327",
    d: "M196.824,98.359c-2.471,0-3.593.073-4.022.567-.373.421-.4,1.775-.03,3.222a.683.683,0,0,1,.411-.507c.948-1.575,3.1-2.334,5.1-2.334a5.578,5.578,0,0,1,3.292.918c.035-1.018.054-1.564.062-1.853h-.989c-.74,0-1.412,0-2.025-.005-.667-.006-1.262-.008-1.794-.008",
    transform: "translate(-71.399 -36.143)",
    fill: "#ebe8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22328",
    "data-name": "Trac\\xE9 22328",
    d: "M208.5,102.023c-.032.389-.049.765-.049,1.137,0,.257.008.513.027.77s.032.57.046.91a6.655,6.655,0,0,0,.111-1.283,10.287,10.287,0,0,0-.135-1.535",
    transform: "translate(-77.257 -37.489)",
    fill: "#9cd8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22329",
    "data-name": "Trac\\xE9 22329",
    d: "M193.239,105.429a6.715,6.715,0,0,0,1.554,2.65,4.8,4.8,0,0,0,3.379,1.037,14.914,14.914,0,0,0,3.547-.489c.027-.035.057-.07.083-.1-.021-.491-.056-.994-.1-1.5.008-.281.016-.548.027-.805a8.172,8.172,0,0,1-4.236,1.046,5.5,5.5,0,0,1-3.3-.84,4.332,4.332,0,0,1-.948-.994",
    transform: "translate(-71.667 -38.741)",
    fill: "#ebe8e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22330",
    "data-name": "Trac\\xE9 22330",
    d: "M207.287,98.375l-.473,0c-.008.289-.03.835-.063,1.856a2.283,2.283,0,0,1,.911,1.38,1.928,1.928,0,0,1-1.027,2.013c-.011.256-.019.524-.027.8.049.508.084,1.011.108,1.5a5.4,5.4,0,0,0,1.132-2.431c-.013-.343-.03-.651-.049-.913s-.024-.513-.024-.77c0-.373.016-.748.049-1.137a19.443,19.443,0,0,0-.538-2.307",
    transform: "translate(-76.58 -36.149)",
    fill: "#c3bcb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22331",
    "data-name": "Trac\\xE9 22331",
    d: "M198.43,99.859c-2,0-4.144.759-5.093,2.334a.678.678,0,0,0-.413.507q.085.341.2.681a4.362,4.362,0,0,0,.949,1,5.508,5.508,0,0,0,3.3.841,8.188,8.188,0,0,0,4.233-1.046,1.927,1.927,0,0,0,1.027-2.015,2.278,2.278,0,0,0-.91-1.38,5.566,5.566,0,0,0-3.292-.918m-1.021,4.954a4.787,4.787,0,0,1-2.769-.672c-1.736-1.362-.616-1.764-.616-1.764a5.171,5.171,0,0,1,4.341-1.9c1.712,0,3.288.633,3.538,1.853.333,1.616-2.234,2.488-4.494,2.488",
    transform: "translate(-71.551 -36.694)",
    fill: "#c3bcb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22332",
    "data-name": "Trac\\xE9 22332",
    d: "M198.8,100.828a5.171,5.171,0,0,0-4.341,1.9s-1.121.405.616,1.764a4.785,4.785,0,0,0,2.769.672c2.261,0,4.828-.872,4.495-2.488-.251-1.221-1.826-1.853-3.538-1.853m-.84,3.46a1.521,1.521,0,0,1-1.6-1.31,1.547,1.547,0,0,1,1.54-1.537c.043,0,.089,0,.132,0a1.566,1.566,0,0,0,1.881.481c.037,0,.075,0,.116,0a1.329,1.329,0,0,1,1.4,1.145,1.349,1.349,0,0,1-1.348,1.345c-.038,0-.076.005-.114.005a1.513,1.513,0,0,1-1.037-.392,1.825,1.825,0,0,1-.834.262c-.046,0-.092.006-.138.006",
    transform: "translate(-71.983 -37.05)",
    fill: "#e2f4fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22333",
    "data-name": "Trac\\xE9 22333",
    d: "M202.831,102.548l-.113,0a1.694,1.694,0,0,0-.546.133,1.28,1.28,0,0,1,.273.7,1.4,1.4,0,0,1-.708,1.27,1.5,1.5,0,0,0,1.035.392c.038,0,.076,0,.116-.006a1.35,1.35,0,0,0,1.348-1.345,1.336,1.336,0,0,0-1.4-1.146",
    transform: "translate(-74.79 -37.682)",
    fill: "#7a7985"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22334",
    "data-name": "Trac\\xE9 22334",
    d: "M199.339,101.791c-.043,0-.089,0-.132.006a1.544,1.544,0,0,0-1.54,1.534,1.518,1.518,0,0,0,1.6,1.31,1.247,1.247,0,0,0,.137-.005,1.805,1.805,0,0,0,.835-.262,1.156,1.156,0,0,1-.368-.759,1.26,1.26,0,0,1,.805-1.208,1.681,1.681,0,0,0-1.337-.616",
    transform: "translate(-73.293 -37.404)",
    fill: "#e7f6fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22335",
    "data-name": "Trac\\xE9 22335",
    d: "M201.957,102.763a1.256,1.256,0,0,0-.805,1.208,1.149,1.149,0,0,0,.368.762,1.4,1.4,0,0,0,.71-1.27,1.273,1.273,0,0,0-.273-.7",
    transform: "translate(-74.574 -37.761)",
    fill: "#aaafba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22336",
    "data-name": "Trac\\xE9 22336",
    d: "M205.648,105.314c2.634-2.358,2.2-5.384,1.067-9.028s2.463,0,2.463,0l.754,7.713Z",
    transform: "translate(-76.227 -34.786)",
    fill: "#132741"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22337",
    "data-name": "Trac\\xE9 22337",
    d: "M159.634,105.08c-2.969.759-10.579,2.045-12.769.089s-1.421-6.107-.076-6.953,4.906-.61,15.168-.816c1.753.491.654,6.931-2.323,7.68m5.467-9.789c-1.232-1.664-12.766-1.8-18.071-1.07s-5.4.91-7.013,5.178,1.867,9.025,5.162,9.336,14.987-.47,16.888-2.356,3.253-6.067,3.512-7.6.257-2.982-.478-3.487",
    transform: "translate(-51.96 -34.467)",
    fill: "#1c3a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22338",
    "data-name": "Trac\\xE9 22338",
    d: "M201.253,103.552c-1.769.67-6.472,1.777-8.384-.1s-2.407-5.781-1.724-6.556c.521-.6,2.069-.578,5.816-.559,1.118.008,2.437.011,3.979,0,1.267.486,2.091,6.54.313,7.213m3.433-5.848c-.194-1.442-.548-2.815-1.154-3.3-1.21-1.58-8.835-1.874-12.158-1.259s-3.339.784-3.374,4.784,3.406,8.544,5.649,8.882,9.754-.232,10.554-1.983.683-5.678.483-7.123",
    transform: "translate(-69.742 -34.116)",
    fill: "#1c3a61"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22339",
    "data-name": "Trac\\xE9 22339",
    d: "M136.423,95.756l.667.467.313,1.416.686.186-.246-2.388-1.1-.219Z",
    transform: "translate(-49.747 -34.989)",
    fill: "#234b7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22340",
    "data-name": "Trac\\xE9 22340",
    d: "M136.5,99.5l-.767.257.149.6,1.116.1.921-2.218-.708-.016Z",
    transform: "translate(-49.493 -36.096)",
    fill: "#234b7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3751",
    "data-name": "Groupe 3751",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3750",
    "data-name": "Groupe 3750",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22341",
    "data-name": "Trac\\xE9 22341",
    d: "M141.065,97.991c-4.495-1.867-4.976-.627-4.189.651a3.353,3.353,0,0,0,2.158,1.492Z",
    transform: "translate(-50.842 -35.658)",
    fill: "#1c3a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22342",
    "data-name": "Trac\\xE9 22342",
    d: "M175.533,106.017c5.735-3.1,8.611-3.025,10.44-1.456s-1.194-7.031-1.194-7.031l-8.715-.154Z",
    transform: "translate(-65.161 -35.782)",
    fill: "#1c3a61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22343",
    "data-name": "Trac\\xE9 22343",
    d: "M146.41,97.1c-1.753.073-3.419,5.446-2.734,7.442a8.532,8.532,0,0,0,1.08,2.434s-1.113-2.566-.737-4.168.937-5.175,3.2-5.591Z",
    transform: "translate(-53.397 -35.682)",
    fill: "#6881a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22344",
    "data-name": "Trac\\xE9 22344",
    d: "M210.4,96.594a11.565,11.565,0,0,1,1.213,5.4c1.062-1.113-.046-4.633-1.213-5.4",
    transform: "translate(-77.975 -35.494)",
    fill: "#8492b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22345",
    "data-name": "Trac\\xE9 22345",
    d: "M185.907,117.031c-.667,0,.14,4.819,2.807,7.05,2.745-1.621,1.559-2.858.2-3.425s-1.431-1.656-2.65-3.331c-.146-.2-.265-.294-.357-.294",
    transform: "translate(-68.891 -43.004)",
    fill: "#fff3ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22346",
    "data-name": "Trac\\xE9 22346",
    d: "M184.483,119.377a3.752,3.752,0,0,0,2.075,2.934c1.129.467,1.393,1.11-.368,2.66s-4.5,1.629-5.208.91a3.3,3.3,0,0,1-.859-1.259,1.874,1.874,0,0,0,1.159,2.447c1.8.643,3.725-.149,5.092-1.013s3.047-3.617,1.135-4.254a7.062,7.062,0,0,1-3.025-2.426",
    transform: "translate(-66.806 -43.866)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22347",
    "data-name": "Trac\\xE9 22347",
    d: "M112.325,61.2c6.445-1.056,18.009-5.305,23.539-2.79s8.484,5.138,22.728,2.055c8.187-1.958,20.912-1.291,23.355-1.672s-1.029-4.971-5.6-7.963c-2.4-12.618-5.583-25.371-17.01-28.639-6.078-4.914-24.868-5.924-33.088,4.279-8.122,3.949-15.23,16.007-12.631,29.852-1.134,1.077-3.568,5.213-1.291,4.878",
    transform: "translate(-41.589 -6.831)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22348",
    "data-name": "Trac\\xE9 22348",
    d: "M113.685,60.385c6.226-1.027,18.185-4.686,23.528-2.258s7.685,4.9,21.448,1.92c7.907-1.893,20.084-1.38,22.448-1.75s-.967-4.3-5.386-7.188c-2.321-12.2-5.387-24.517-16.429-27.677-5.873-4.741-24.031-5.721-31.969,4.136-7.853,3.817-14.714,15.465-12.207,28.841-1.094,1.042-3.636,4.295-1.431,3.976",
    transform: "translate(-42.114 -7.335)",
    fill: "#e3eaef"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3753",
    "data-name": "Groupe 3753",
    transform: "translate(71.743 12.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3752",
    "data-name": "Groupe 3752",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22349",
    "data-name": "Trac\\xE9 22349",
    d: "M133.745,25.22c-.432,0-.9.013-1.4.043a17.8,17.8,0,0,0-5.022,4.239c-6.748,3.279-12.766,12.341-12.734,23.317a30.352,30.352,0,0,0,.527,5.524c-.784.746-2.307,2.621-2.3,3.512,0,.3.173.486.6.486a2.208,2.208,0,0,0,.276-.022c3.506-.578,8.827-1.991,13.76-2.683-4.459-1.224-1.863-2.912-1.863-2.912a10.106,10.106,0,0,1-1.924.182c-1.715,0-4.036-.454-4.535-2.8-.813-3.817-.77-20.981,13.306-25.822,5.924-2.037,4.984-3.068,1.316-3.068",
    transform: "translate(-112.814 -21.893)",
    fill: "#bac9d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22350",
    "data-name": "Trac\\xE9 22350",
    d: "M160.916,16.262c12.647,3.2,21.513,7.907,22.439,22.472,1.75.524-2.269-14.333-5.67-17.356s6.3,2.666,10.462,11.645S192.6,47.569,192.6,47.569s8.071,6.723,5.213,7.774,6.058,3.628,6.058,3.628.519-10.416.373-10.9-16.256-30.554-16.256-30.554l-18.928-6.4Z",
    transform: "translate(-130.49 -16.71)",
    fill: "#f2faff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3755",
    "data-name": "Groupe 3755",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3754",
    "data-name": "Groupe 3754",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22352",
    "data-name": "Trac\\xE9 22352",
    d: "M181.777,23.481c7.547,6.172,8.385,11.218,9.762,22.644,1.037-2.969-.843-20.073-9.762-22.644",
    transform: "translate(-67.455 -8.628)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22353",
    "data-name": "Trac\\xE9 22353",
    d: "M134.568,29.018c9.532-.621,18.971,4.795,23.579,17.528.721,1.194,1.678,1.431,1.812.151s-3.247-13.5-8.971-17.76-6.7-8.026-16.421.081",
    transform: "translate(-50.108 -8.908)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22354",
    "data-name": "Trac\\xE9 22354",
    d: "M146.976,68.62c-5.859,3.385-13.169,4.919-18.239,4.525-.559-1.242,6.153-.113,18.239-4.525",
    transform: "translate(-47.954 -25.215)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22355",
    "data-name": "Trac\\xE9 22355",
    d: "M190.461,69.595c-8.222-.308-27.893,3.59-27.893,3.59s26.581-6.726,27.893-3.59",
    transform: "translate(-60.397 -25.267)",
    fill: "#adc0cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22356",
    "data-name": "Trac\\xE9 22356",
    d: "M185.014,133.54c-4.327,2.424-11.839,5.119-17.564,2.356a12.037,12.037,0,0,0,11.281,3.168c3.315-.626,5.967-3.674,6.283-5.524",
    transform: "translate(-62.191 -49.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22357",
    "data-name": "Trac\\xE9 22357",
    d: "M129.863,45.875a17.372,17.372,0,0,1-1.642,2.366,3.062,3.062,0,0,0-3.333,3.782c.772,3.992,6.237,2.377,5.54-1.362a2.9,2.9,0,0,0-1.4-2.026c.695-.94,1.321-1.912,2.086-2.779.438.125,1.054-.038,1.492.087.154.211-.476.821-.741,1.191-.319.44-.619.942-.872,1.307,1.934,3.16.359,6.666-2.469,7.4a3.947,3.947,0,0,1-4.809-2.882c-.781-2.717.346-5.386,2.71-6.124.872-.27,1.418-.068,1.75-.932.6-.068,1.091.043,1.688-.027",
    transform: "translate(-46.029 -16.85)",
    fill: "#0093d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22358",
    "data-name": "Trac\\xE9 22358",
    d: "M139.462,45.9c.024,1.137-.024,2.223.038,3.393a6.218,6.218,0,0,0,1.2.043,7.837,7.837,0,0,1,.043,1.018,18.51,18.51,0,0,1-2.369.07c-.025-1.5-.054-3,0-4.452.422-.119.67.044,1.094-.073",
    transform: "translate(-51.494 -16.866)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22359",
    "data-name": "Trac\\xE9 22359",
    d: "M145.314,50.255a4.97,4.97,0,0,1-1.027.089c-.052-.738.337-2.685-.671-2.353-.478.5-.132,1.564-.226,2.326a3.13,3.13,0,0,1-.954.07c-.13-1.559.013-2.926-.1-4.463.3.038.683-.037.968.027a5.282,5.282,0,0,1,.015,1.248,3.814,3.814,0,0,1,.984-.3c1.294.022.931,2.218,1.01,3.352",
    transform: "translate(-52.963 -16.876)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22360",
    "data-name": "Trac\\xE9 22360",
    d: "M152.613,45.768c.3.035.681-.04.97.016.113.307-.038.437.073.74-.4.119-.64-.014-1.023.078-.008-.278-.038-.57-.019-.835",
    transform: "translate(-56.737 -16.816)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22361",
    "data-name": "Trac\\xE9 22361",
    d: "M131.142,50.417c.3.521.281,1.964-.254,2.331a5.735,5.735,0,0,0-1.321.059,21.134,21.134,0,0,1,1.575-2.39",
    transform: "translate(-48.27 -18.526)",
    fill: "#0093d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22362",
    "data-name": "Trac\\xE9 22362",
    d: "M148.957,49.86c.813-.2.619-1.772-.287-1.478a.755.755,0,0,0,.287,1.478m1.6-.605c-.157,2.091-3.712,2.2-3.493-.351a1.755,1.755,0,0,1,3.493.351",
    transform: "translate(-54.695 -17.394)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22363",
    "data-name": "Trac\\xE9 22363",
    d: "M158.7,45.647c.359-.087.591.022.956-.065a6.55,6.55,0,0,1,.046.956.356.356,0,0,0,.387.062,6.807,6.807,0,0,1,.006.743l-.429.1a16.627,16.627,0,0,1,.04,2.383,6.719,6.719,0,0,0-.959.083c-.052-.821-.014-1.591-.038-2.4a.348.348,0,0,0-.386-.059c-.092-.27.057-.378-.057-.662l.467-.259a3.717,3.717,0,0,1-.032-.889",
    transform: "translate(-58.814 -16.75)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22364",
    "data-name": "Trac\\xE9 22364",
    d: "M152.6,47.419a4.9,4.9,0,0,0,1.027-.081c0,1.078-.035,2.128.054,3.263a5.054,5.054,0,0,1-1.029.094c-.032-1.1,0-2.166-.051-3.277",
    transform: "translate(-56.734 -17.395)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22365",
    "data-name": "Trac\\xE9 22365",
    d: "M156.768,48.227a1.611,1.611,0,0,1-1.242-.24l-.184.192c.395.521,1.167.254,1.426.8.762,1.591-2.309,2.588-2.42.576a3.8,3.8,0,0,0,.886-.057c.038.281.195.386.44.349l.187-.2c-.5-.581-1.542-.268-1.491-1.472.049-1.073,2.337-1.535,2.4.051",
    transform: "translate(-57.376 -17.343)",
    fill: "#171517"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22366",
    "data-name": "Trac\\xE9 22366",
    d: "M130.335,53.848c.157.837.194,2.183-.5,2.642-.878.008-1.756.011-2.663.065-.068-.553.008-1.005-.049-1.556a16.772,16.772,0,0,1,2.366-.059,5.485,5.485,0,0,0,.843-1.091",
    transform: "translate(-47.373 -19.787)",
    fill: "#0093d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22367",
    "data-name": "Trac\\xE9 22367",
    d: "M184.758,134.188c-4.554,2.685-13.571,5.089-19.165,1.329-.621-.4.392-.767,2.231.143s8.028,2.553,16.44-2.18c.57-.335.9.235.494.708",
    transform: "translate(-61.441 -49.012)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22368",
    "data-name": "Trac\\xE9 22368",
    d: "M185.508,134.247a7.519,7.519,0,0,1-5.373,5.256c-2.12.6-10.94,1.6-12.685-3.609l.605.154s2,3.22,7.7,2.826,7.728-1.029,9.257-5.335a6.533,6.533,0,0,1,.494.708",
    transform: "translate(-62.191 -49.07)",
    fill: "#ae8e7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22369",
    "data-name": "Trac\\xE9 22369",
    d: "M324.4,48.951c6.47-3.676,11.5-7.928,12.642-9.635s2.779-5.848,2.053-6.734c1.029-.794.729-5.819-1.961-5.678,1.167-2.055,2.7-4.373-2.909-5.659.921-2.069.826-5.022-5.935-5.562,1.524-2.434,2.664-5.335-1.936-6.429-2.588-.416-4.325,3.091-4.325,3.091-1.55,3.941-3.557,10.459-4.387,10.489-1.71-1.988-3.941-4.473-2.933-7.823-.441-2.723-3.871-8.62-8.531-9.857s-5.454,2.361-4.67,3.23c1.586.351,6.351,4.976,5.578,10.3-1.034,3.539-1.18,6.359-.762,7.718s3.206,15.783,3.206,15.783,3.366,10.746,14.87,6.767",
    transform: "translate(-111.354 -1.8)",
    fill: "#83807e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22370",
    "data-name": "Trac\\xE9 22370",
    d: "M306.707,4.913a7.369,7.369,0,0,1,1.478.246c4.659,1.237,8.09,7.131,8.53,9.857-.441-2.726-3.871-8.62-8.53-9.857a7.369,7.369,0,0,0-1.478-.246",
    transform: "translate(-113.362 -1.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22371",
    "data-name": "Trac\\xE9 22371",
    d: "M305.1,4.9a3.57,3.57,0,0,0-1.958.508c7.59.986,8.879,5.243,10.049,7.139s.216,5.235.91,6.823S321.029,27,321.029,27a18.1,18.1,0,0,0-2.693-4.17c-1.416-1.648-3.191-3.633-3.185-6.17a5.622,5.622,0,0,1,.251-1.653c-.44-2.726-3.869-8.62-8.528-9.857a7.462,7.462,0,0,0-1.48-.245c-.1-.006-.2-.008-.3-.008",
    transform: "translate(-112.051 -1.801)",
    fill: "#bdbab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22372",
    "data-name": "Trac\\xE9 22372",
    d: "M350.358,62.143a57.581,57.581,0,0,1-8.344,6.253c-.025.143-.049.287-.073.429a32.316,32.316,0,0,0,8.417-6.683",
    transform: "translate(-126.309 -22.835)",
    fill: "#a69e9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22373",
    "data-name": "Trac\\xE9 22373",
    d: "M339.384,73.205c-.424.254-.856.508-1.294.759.419-.149.835-.316,1.248-.5.016-.089.033-.176.046-.259",
    transform: "translate(-124.894 -26.9)",
    fill: "#14182e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22374",
    "data-name": "Trac\\xE9 22374",
    d: "M341.323,72.028c-.4.249-.8.5-1.213.746-.016.081-.03.17-.046.259.4-.178.8-.37,1.189-.576.022-.143.046-.287.07-.429",
    transform: "translate(-125.619 -26.467)",
    fill: "#110f23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22375",
    "data-name": "Trac\\xE9 22375",
    d: "M349.847,49.7c-.395.287-.848.559-1.278.853-.989,5.754-7.785,9.592-18.474,15.452a9.133,9.133,0,0,0,1.086.065,12.015,12.015,0,0,0,3.971-.743c.437-.251.87-.505,1.294-.759s.816-.5,1.213-.746a57.41,57.41,0,0,0,8.346-6.253,8.23,8.23,0,0,0,1.686-2.334c1.9-3.055,2.153-4.824,2.156-5.535",
    transform: "translate(-121.956 -18.263)",
    fill: "#5b5352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22376",
    "data-name": "Trac\\xE9 22376",
    d: "M312.3,54.259c-2-7.885-3.517-16.5-3.517-16.5s5.845,16.186,6.288,21.151a11.638,11.638,0,0,1-2.771-4.646",
    transform: "translate(-114.124 -13.873)",
    fill: "#b3c555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22377",
    "data-name": "Trac\\xE9 22377",
    d: "M309.56,41.961c-.094-2.19-.9-5.621-1.186-8.25s-1.829-8.141-1.853-8.987.8-4.476.778-8.077-2.28-7.6-4.892-8.865c-1.373-.778.548-5.051,5.8-1.669s6.294,7.742,5.929,9.276a7.807,7.807,0,0,0,1.421,5.225c.934.967,6.669,8.609,6.251,11.2-.138,1.261.759-1.018-.311-3.474s-5.237-7.688-5.237-7.688-2.018-1.869-1.524-5.867S309.8,5.421,306.67,4.549s-6.165.451-5.132,3.609c.5,1.156,1.578.859,2.831,2.55a11.058,11.058,0,0,1,2.2,7.806c-.783,4.122-1.518,5.991-.383,8.59.321,1.924,2.007,14.079,3.376,14.857",
    transform: "translate(-111.387 -1.575)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22378",
    "data-name": "Trac\\xE9 22378",
    d: "M340.557,63.758c5.222-2.617,10.243-6.867,10.978-8.733s1.945-3.428,2-4.482l.054-1.056s.532-.748.64-.108-1.623,5.349-2.012,6.035-9.128,9.819-11.662,8.344",
    transform: "translate(-125.801 -18.05)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22379",
    "data-name": "Trac\\xE9 22379",
    d: "M361.917,45.281a5.094,5.094,0,0,1-.038.9c.008.024.011.049.016.073a3.615,3.615,0,0,0,.068-.775,1.8,1.8,0,0,0-.046-.194",
    transform: "translate(-133.635 -16.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22380",
    "data-name": "Trac\\xE9 22380",
    d: "M357.668,39.686a6.554,6.554,0,0,0-.543.924c1.17.343,2.474.8,3.009,3.511a5.354,5.354,0,0,0,.035-.9.631.631,0,0,0-.022-.073c-.632-2.042-.883-2.323-2.433-2.934.151-.183.256-.313.332-.4a3.026,3.026,0,0,0-.378-.13",
    transform: "translate(-131.889 -14.583)",
    fill: "#bdbab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22381",
    "data-name": "Trac\\xE9 22381",
    d: "M356.732,43.622c.691,1.588-.9,2.283-2.218,3.2s-4.371,2.593-5.532,1.9-4.108-2.334-1.924-3.63c-.162,1.015.252,2.25,2.631,3.277,1.178-.251,7.388-2.572,6.472-5.265-.635-2.045-.886-2.326-2.437-2.934l.5-.61s2.129-.54,2.5,4.068",
    transform: "translate(-127.901 -14.527)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22382",
    "data-name": "Trac\\xE9 22382",
    d: "M340.939,11.785h0a7.411,7.411,0,0,1,1.659.583,3.192,3.192,0,0,0-1.659-.583",
    transform: "translate(-125.941 -4.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22383",
    "data-name": "Trac\\xE9 22383",
    d: "M337.194,11.77c-1.92,0-3.785,1.837-5.662,7.48-.168.646-.168.908-.059.908.362,0,1.9-2.845,2.461-4.273a3.357,3.357,0,0,1,3.182-2.342,4.241,4.241,0,0,1,1.013.13,4.825,4.825,0,0,0,1.137.17c.743,0,.748-.348.748-.348a2.744,2.744,0,0,0-.924-1.129,7.2,7.2,0,0,0-1.659-.586c-.078-.006-.157-.008-.238-.008",
    transform: "translate(-122.435 -4.325)",
    fill: "#bdbab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22384",
    "data-name": "Trac\\xE9 22384",
    d: "M349.157,22.856a7.12,7.12,0,0,1,1.359.572,3.015,3.015,0,0,0-1.359-.572",
    transform: "translate(-128.961 -8.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22385",
    "data-name": "Trac\\xE9 22385",
    d: "M346.273,22.756a12.919,12.919,0,0,0-2.4.313.849.849,0,0,0-.316,1.041,3.77,3.77,0,0,1,1.71-.362c1.434,0,2.9.595,3.166,1.2a1.988,1.988,0,0,0,1.2,1.089c.173,0,.232-.17.043-.6a3.733,3.733,0,0,0-1.242-2.048,7.078,7.078,0,0,0-1.359-.573,4.881,4.881,0,0,0-.8-.062",
    transform: "translate(-126.873 -8.362)",
    fill: "#bdbab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22386",
    "data-name": "Trac\\xE9 22386",
    d: "M353.577,30.144c-.043.07-.081.135-.119.2s-.049.119-.075.181c2.544.583,3.619,1.378,3.924,2.266-.159-1.129-1.256-1.986-3.73-2.645",
    transform: "translate(-130.514 -11.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22387",
    "data-name": "Trac\\xE9 22387",
    d: "M353.253,30.454a3.352,3.352,0,0,0-.43.9c2.177.221,4.516,1.3,3.8,3.588A3.541,3.541,0,0,0,357.1,32.9c-.3-.889-1.38-1.683-3.925-2.266.027-.059.052-.121.076-.182",
    transform: "translate(-130.308 -11.191)",
    fill: "#bdbab8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22388",
    "data-name": "Trac\\xE9 22388",
    d: "M352.813,34.543a4.94,4.94,0,0,1-2.12,3.117c-.5.343-4.211,3.552-5.6,3.814s-3.528-1.386-3.812-2.037a5.461,5.461,0,0,1-.362-1.132l.527.03s2.026,3.757,4.606,1.988,6.659-4.833,6.461-7.067-2.839-2.374-3.712-2.9l.616-.656s5.113,1.383,3.4,4.838",
    transform: "translate(-125.934 -10.915)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22389",
    "data-name": "Trac\\xE9 22389",
    d: "M340.749,22.12c4.711-1.021,7.642,3.633,4.571,6.645-1.913,2.123-5,6.565-7.391,6.7s-4.768-1.61-5.151-3.377c.572-.764.689-.351.689-.351s1.731,4.271,5.524,2.62c1.037-.581,7.423-7.228,6.964-8.576a4.6,4.6,0,0,0-5.826-2.866c-.144-.327.621-.8.621-.8",
    transform: "translate(-122.942 -8.075)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22390",
    "data-name": "Trac\\xE9 22390",
    d: "M329.578,28.856a10.992,10.992,0,0,0,5.654-4.681,57.087,57.087,0,0,1,4.176-7.139c.975-1.166.589-4.84-3-5.643s-5.335,2.621-5.643,4.084-3.6,9.7-3.6,9.7l.378.873s3.9-10.567,5.168-12.3c.132-1.24,2.858-2.726,5.748-.435.724.424,1.027,2.361-.645,4.716a53.1,53.1,0,0,0-3.723,6.945c-2,1.607-4.73,3.39-4.514,3.887",
    transform: "translate(-120.88 -4.142)",
    fill: "#111030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22391",
    "data-name": "Trac\\xE9 22391",
    d: "M197.547,54.374c7.558.419,7,.424,7.258,1.772,1.27,6.635,3.8,6.165-7.537,6.726s.278-8.5.278-8.5",
    transform: "translate(-71.324 -19.98)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22392",
    "data-name": "Trac\\xE9 22392",
    d: "M147.18,64.958c-18.411,1.264-31.578,3.212-33.641,3.822s-1.065-6.416.148-7.056,31.027-5.256,34-4.611-.505,7.844-.505,7.844",
    transform: "translate(-41.944 -20.964)",
    fill: "#484747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22393",
    "data-name": "Trac\\xE9 22393",
    d: "M172.432,67.393c-4.984.543-6.872-2.226-7.553-5.022s.224-5.707,3.806-5.91,3.747,10.932,3.747,10.932",
    transform: "translate(-61.169 -20.746)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22394",
    "data-name": "Trac\\xE9 22394",
    d: "M191.94,59.438c-1.586,5.635-7.329,6.364-11.866,6.529s-9.417-.529-10.556-6.308-3.242-9.978,3.868-10.635,14.187-1.98,14.922,2.688c3.5,2.777,4.182,5.978,3.633,7.726",
    transform: "translate(-62.51 -17.762)",
    fill: "#353233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22395",
    "data-name": "Trac\\xE9 22395",
    d: "M191.205,56.971c-5.265.478-10.006,3.115-9.7,5.462s.552,3.366,5.025,3.487,8.265-2.285,9.068-4.635-1.821-4.268-4.39-4.314",
    transform: "translate(-67.349 -20.935)",
    fill: "#fff1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22396",
    "data-name": "Trac\\xE9 22396",
    d: "M185.69,55.381c-4.508.832-10.424,3.619-10.924,7.644-.07,1.362,1.267.23,1.464-.626s.464-4.152,9.46-7.018",
    transform: "translate(-64.878 -20.35)",
    fill: "#646363"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3757",
    "data-name": "Groupe 3757",
    transform: "translate(106.851 30.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3756",
    "data-name": "Groupe 3756",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22397",
    "data-name": "Trac\\xE9 22397",
    d: "M189.441,52.513c-3.76-2.177-3.668-1.8-5.446-1.9a9.6,9.6,0,0,0-2.28.018,6.485,6.485,0,0,1,2.953-1.126c1.588-.116-.464-1.367-3.034-1.951s-11.672.695-13.168,1.192-1.788,2.59-2.207,3.636-6.451-3.274-1.273-5.208,24.438-3,24.438-3Z",
    transform: "translate(-166.326 -46.807)",
    fill: "#646363"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3759",
    "data-name": "Groupe 3759",
    transform: "translate(1.043 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3758",
    "data-name": "Groupe 3758",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22399",
    "data-name": "Trac\\xE9 22399",
    d: "M190.288,64.066c.113,1.331-.395,2.464-1.132,2.526s-1.432-.967-1.545-2.3.394-2.464,1.135-2.526,1.429.967,1.542,2.3",
    transform: "translate(-69.593 -22.696)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3761",
    "data-name": "Groupe 3761",
    transform: "translate(71.45 36.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3760",
    "data-name": "Groupe 3760",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22400",
    "data-name": "Trac\\xE9 22400",
    d: "M118.453,69.052c-5.313-3.039-3.172-13.771-1.418-15.413s-13.484,6.528-13.484,6.528l-.289,11.3Z",
    transform: "translate(-109.01 -55.716)",
    fill: "#292928"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverWorker);
export default __webpack_public_path__ + "static/media/cover_worker.b7fbca645f37ea3cce33e0cd4e8c6684.svg";
export { ForwardRef as ReactComponent };